{
  "common": {
    "main": {
      "project": "Проект",
      "form": "Форма",
      "version": "Версия",
      "formSettings": "Настройки формы",
      "user": "Пользователь",
      "organization": "Организация",
      "server": "Сервер",
      "url": "URL"
    },
    "buttons": {
      "ok": "ОК",
      "cancel": "Отмена",
      "save": "Сохранить",
      "add": "Добавить",
      "edit": "Редактировать",
      "delete": "Удалить",
      "refresh": "Обновить",
      "create": "Создать",
      "submit": "Отправить",
      "clear": "Очистить",
      "selectAll": "Выбрать все",
      "back": "Назад",
      "next": "Далее",
      "previous": "Предыдущий",
      "close": "Закрыть",
      "confirm": "Подтвердить",
      "yes": "Да",
      "no": "Нет",
      "search": "Поиск",
      "filter": "Фильтр",
      "export": "Экспорт",
      "import": "Импорт",
      "download": "Скачать",
      "upload": "Загрузить",
      "view": "Просмотр",
      "preview": "Предпросмотр",
      "copy": "Копировать",
      "assign": "Назначить",
      "unassign": "Отвязать",
      "retry": "Повторить",
      "loading": "Загрузка..."
    },
    "dialogs": {
      "cancel": "Отмена",
      "close": "Закрыть",
      "confirm": "Подтвердить",
      "delete": "Удалить",
      "save": "Сохранить изменения",
      "confirmTitle": "Подтвердите действие",
      "unsavedChanges": {
        "title": "Несохранённые изменения",
        "message": "Есть несохранённые изменения. Закрыть без сохранения?"
      }
    },
    "table": {
      "headers": {
        "name": "Название",
        "description": "Описание",
        "statistics": "Статистика",
        "status": "Статус",
        "actions": "Действия",
        "createdAt": "Дата создания",
        "updatedAt": "Дата обновления",
        "created": "Создана",
        "updated": "Обновлена",
        "type": "Тип",
        "version": "Версия",
        "id": "ID",
        "email": "Email",
        "role": "Роль",
        "user": "Пользователь",
        "project": "Проект",
        "organization": "Организация",
        "lastSubmission": "Последнее отправление",
        "server": "Сервер",
        "url": "URL",
        "format": "Формат",
        "count": "Количество",
        "size": "Размер",
        "date": "Дата",
        "time": "Время",
        "severity": "Серьезность",
        "field": "Основное поле",
        "form": "Форма",
        "state": "Состояние",
        "roles": "Роли",
        "groups": "Группы",
        "formId": "ID формы",
        "permissions": "Разрешения",
        "enabled": "Включено",
        "disabled": "Отключено",
        "submissions": "Отправки",
        "publishedAt": "Опубликовано"
      },
      "pagination": {
        "page": "Страница",
        "of": "из",
        "perPage": "на странице",
        "showing": "Показано",
        "to": "по",
        "totalEntries": "всего записей",
        "resultsText": "результатов.",
        "perPageText": "Результатов на странице"
      },
      "ariaLabels": {
        "viewDetails": "Просмотреть детали",
        "edit": "Редактировать",
        "delete": "Удалить",
        "previousPage": "Предыдущая страница",
        "nextPage": "Следующая страница"
      }
    },
    "status": {
      "active": "Активный",
      "inactive": "Неактивный",
      "archived": "Архивирован",
      "draft": "Черновик",
      "published": "Опубликован",
      "pending": "Ожидание",
      "completed": "Завершено",
      "failed": "Ошибка",
      "success": "Успешно",
      "error": "Ошибка",
      "warning": "Предупреждение",
      "info": "Информация",
      "loading": "Загрузка",
      "notSet": "Не установлено",
      "notSpecified": "Не указано",
      "notAvailable": "Н/Д",
      "unknown": "Неизвестно",
      "enabled": "Включено",
      "disabled": "Отключено"
    },
    "messages": {
      "confirmDelete": "Вы уверены, что хотите удалить",
      "confirmDeleteWithName": "Вы уверены, что хотите удалить \"{name}\"?",
      "deleteSuccess": "Удалено успешно",
      "deleteError": "Ошибка при удалении",
      "saveSuccess": "Сохранено успешно",
      "saveError": "Ошибка при сохранении",
      "createSuccess": "Создано успешно",
      "createError": "Ошибка при создании",
      "updateSuccess": "Обновлено успешно",
      "updateError": "Ошибка при обновлении",
      "error": "Произошла ошибка",
      "loadError": "Ошибка при загрузке",
      "noData": "Нет данных",
      "noResults": "Нет результатов",
      "required": "Это поле обязательно",
      "invalidEmail": "Пожалуйста, введите корректный email",
      "confirmDeleteWithType": "Вы уверены, что хотите удалить \"{name}\" ({type})?",
      "bulkOperationSuccess": "Массовая операция выполнена успешно",
      "bulkOperationError": "Ошибка при выполнении массовой операции",
      "operationFailed": "Не удалось выполнить операцию",
      "unsavedChanges": "Форма содержит несохраненные изменения. Вы уверены, что хотите закрыть её?",
      "created": "создан",
      "updated": "обновлен",
      "invalidUrl": "Пожалуйста, введите корректный URL"
    },
    "statistics": {
      "title": "Статистика",
      "subtitle": "Просмотр метрик организации, состояний форм и активности по проектам.",
      "overall": "Общая статистика",
      "byState": "Формы по состояниям",
      "projectDetails": "Детали по проектам",
      "projectLedger": "Реестр проектов",
      "pipeline": "Состояние",
      "projectCount": "{count} проектов",
      "noActiveForms": "Нет активных форм",
      "projects": "Проектов",
      "totalForms": "Всего форм",
      "activeForms": "Активных форм",
      "submissions": "Отправок",
      "forms": "Форм",
      "lastUpdated": "Обновлено",
      "noDataToDisplay": "Нет данных для отображения"
    },
    "viewMode": {
      "cards": "Карточки",
      "table": "Таблица",
      "list": "Список",
      "grid": "Сетка"
    },
    "time": {
      "today": "сегодня",
      "yesterday": "вчера",
      "thisWeek": "на этой неделе",
      "lastWeek": "на прошлой неделе",
      "thisMonth": "в этом месяце",
      "lastMonth": "в прошлом месяце",
      "allTime": "за все время",
      "last7Days": "Последние 7 дней",
      "last30Days": "Последние 30 дней",
      "last90Days": "Последние 90 дней",
      "customRange": "Произвольный диапазон",
      "startDate": "Дата начала",
      "endDate": "Дата окончания",
      "justNow": "Только что",
      "minutesAgo": "{count} мин. назад",
      "hoursAgo": "{count} ч. назад",
      "daysAgo": "{count} дн. назад",
      "never": "Никогда"
    },
    "placeholders": {
      "enterName": "Введите название",
      "enterDescription": "Введите описание",
      "enterEmail": "Введите email",
      "enterUrl": "Введите URL",
      "search": "Поиск...",
      "selectOption": "Выберите вариант"
    },
    "formState": {
      "title": "Изменение статуса формы",
      "form": "Форма",
      "currentStatus": "Текущий статус",
      "newStatus": "Новый статус",
      "pleaseSelectStatus": "Пожалуйста, выберите статус",
      "statusChangedSuccessfully": "Статус формы {formName} успешно изменен на {status}",
      "errorChangingStatus": "Ошибка изменения статуса формы"
    }
  },
  "admin": {
    "agent": {
      "title": "Hermes Agent",
      "subtitle": "Мониторинг и управление интеграцией AI-агента",
      "back": "Назад к панели",
      "sections": {
        "metrics": "Пульс"
      },
      "health": {
        "title": "Состояние интеграции",
        "checkNow": "Проверить сейчас",
        "latency": "Задержка",
        "lastCheck": "Последняя проверка"
      },
      "stats": {
        "activeSubs": "Активные подписки",
        "activeSubsHint": "всего {total}",
        "requestsToday": "Запросов сегодня",
        "tokensToday": "Токенов сегодня",
        "nearQuota": "Org у квоты",
        "nearQuotaHint": ">80% использовано"
      },
      "config": {
        "title": "Конфигурация (read-only)"
      },
      "jobs": {
        "title": "RQ Jobs (аналитические отчёты)",
        "empty": "Нет недавних jobs"
      },
      "digests": {
        "title": "Проактивные дайджесты",
        "trigger": "Запустить вручную",
        "historyTitle": "История дайджестов",
        "historyEmpty": "Запусков дайджестов пока нет."
      },
      "selfHeal": {
        "title": "Self-healing задачи",
        "trigger": "Запустить"
      },
      "incident": {
        "title": "Требует внимания",
        "banner": "Hermes или MCP недоступны. Функции агента могут работать с ограничениями."
      },
      "subscriptions": {
        "title": "Подписки агента",
        "subtitle": "Управление тарифами, квотами и функциями по организациям",
        "searchPlaceholder": "Поиск организации...",
        "allTiers": "Все тарифы",
        "editTitle": "Редактировать подписку",
        "resetTitle": "Сбросить usage",
        "resetMessage": "Сбросить счётчики usage для {name}?",
        "resetConfirm": "Сбросить",
        "empty": "Подписки не найдены",
        "tierDefaultsTitle": "Значения тарифов по умолчанию",
        "tierDefaultsHint": "Справочные лимиты из backend SSOT. Смена тарифа в форме применяет эти значения (переопределения возможны).",
        "columns": {
          "org": "Организация",
          "tier": "Тариф",
          "fiveHour": "5ч",
          "week": "Неделя",
          "month": "Месяц",
          "features": "Функции"
        },
        "tierDefaults": {
          "fiveHour": "5ч (req / tok)",
          "week": "Неделя (req / tok)",
          "month": "Месяц (req / tok)"
        }
      },
      "usage": {
        "title": "Использование агента",
        "subtitle": "Журнал вызовов агента по организациям",
        "orgIdPlaceholder": "ID организации",
        "allFeatures": "Все функции",
        "empty": "Нет событий usage",
        "columns": {
          "time": "Время",
          "org": "Организация",
          "user": "Пользователь",
          "feature": "Функция",
          "tokens": "Токены"
        }
      },
      "audit": {
        "title": "Аудит tool-calls",
        "subtitle": "Журнал вызовов MCP-инструментов (особенно write-actions)",
        "orgIdPlaceholder": "ID организации",
        "toolPlaceholder": "Имя инструмента",
        "writeOnly": "Только write-инструменты",
        "detailTitle": "Детали аудита",
        "detail": "Детали",
        "empty": "Нет записей аудита",
        "write": "Запись",
        "read": "Чтение",
        "columns": {
          "time": "Время",
          "org": "Организация",
          "tool": "Инструмент",
          "write": "Запись"
        }
      }
    },
    "dialogs": {
      "deleteProject": {
        "title": "Удалить проект",
        "message": "Это действие необратимо. Все связанные формы будут удалены.",
        "formsCount": "Будет удалено форм: {count}",
        "confirm": "Удалить навсегда"
      },
      "deleteOrganization": {
        "title": "Удалить организацию",
        "message": "Это действие необратимо. Затронуты все проекты и пользователи организации.",
        "confirm": "Удалить навсегда"
      },
      "deleteForm": {
        "title": "Удалить форму",
        "message": "Это действие необратимо.",
        "confirm": "Удалить навсегда"
      },
      "deleteUser": {
        "title": "Удалить пользователя",
        "message": "Это действие необратимо. Пользователь потеряет доступ ко всем организациям.",
        "confirm": "Удалить навсегда"
      },
      "projectDetails": "Проект: {name}",
      "organizationDetails": "Организация: {name}",
      "formDetails": "Форма: {name}",
      "userDetails": "Пользователь: {name}",
      "close": "Закрыть",
      "createUser": {
        "title": "Создание пользователя"
      },
      "editUser": {
        "title": "Редактирование пользователя"
      },
      "fullName": "Полное имя",
      "superuser": "Суперпользователь",
      "active": "Активен"
    },
    "back": "Назад к панели",
    "chrome": {
      "sessionLabel": "Суперпользователь · все действия логируются",
      "exit": "Выйти из режима",
      "menuTitle": "Администрирование",
      "sessionWarning": "Административная сессия истечёт через {time}.",
      "extendSession": "Продлить сессию"
    },
    "nav": {
      "groups": {
        "overview": "Обзор",
        "directory": "Каталог",
        "access": "Доступ",
        "integrations": "Интеграции",
        "platform": "Платформа"
      },
      "dashboard": "Панель управления",
      "analytics": "Аналитика",
      "users": "Пользователи",
      "organizations": "Организации",
      "projects": "Проекты",
      "forms": "Формы",
      "roles": "Роли и разрешения",
      "permissionGroups": "Группы разрешений",
      "agent": "Hermes Agent",
      "agentDashboard": "Панель агента",
      "agentSubscriptions": "Подписки агента",
      "agentUsage": "Использование",
      "agentAudit": "Аудит агента",
      "globalOdk": "Глобальные ODK серверы",
      "system": "Система",
      "audit": "Аудит",
      "subscriptions": "Биллинг"
    },
    "pagination": {
      "shown": "Показано {start} - {end} из {total}",
      "pageOf": "Страница {page} из {pages}",
      "previous": "Предыдущая",
      "next": "Следующая"
    },
    "common": {
      "tryAgain": "Попробовать снова",
      "showDeleted": "Показать удаленные",
      "hideDeleted": "Скрыть удаленные",
      "showArchived": "Показать архивные",
      "hideArchived": "Скрыть архивные",
      "allOrganizations": "Все организации",
      "allProjects": "Все проекты",
      "allRoles": "Все роли",
      "allStatuses": "Все статусы",
      "totalRecords": "Всего записей: {count}",
      "orgIdPrefix": "Орг. #{id}",
      "projectIdPrefix": "Проект #{id}",
      "notSet": "Не установлен",
      "health": {
        "healthy": "Работает",
        "degraded": "Деградация",
        "disabled": "Отключён",
        "unhealthy": "Ошибка",
        "unknown": "Неизвестно"
      }
    },
    "pages": {
      "users": {
        "title": "Управление пользователями",
        "subtitle": "Просмотр и управление всеми пользователями системы",
        "addUser": "Добавить пользователя",
        "searchPlaceholder": "Поиск пользователей...",
        "superuserBadge": "Суперпользователь",
        "userBadge": "Пользователь",
        "statsTotal": "Всего",
        "statsSuperusers": "Суперпользователи",
        "statsOwners": "Владельцы",
        "statsActive": "Активные",
        "loadError": "Не удалось загрузить пользователей",
        "empty": "Нет пользователей по текущим фильтрам"
      },
      "organizations": {
        "title": "Управление организациями",
        "subtitle": "Просмотр и управление всеми организациями системы",
        "searchPlaceholder": "Поиск по названию или описанию организации...",
        "sectionTitle": "Организации",
        "loading": "Загрузка организаций...",
        "empty": "Организации не найдены",
        "loadError": "Ошибка загрузки организаций",
        "restored": "Организация восстановлена",
        "restoreError": "Ошибка восстановления организации",
        "owner": "Владелец",
        "created": "Создана",
        "deletedBadge": "Удалена",
        "activeBadge": "Активна",
        "agentSubscription": "Подписка агента",
        "statsTotal": "Всего организаций",
        "statsActive": "Активных",
        "statsProjects": "Проектов",
        "statsForms": "Форм"
      },
      "projects": {
        "title": "Управление проектами",
        "subtitle": "Просмотр и управление всеми проектами системы",
        "searchPlaceholder": "Поиск по названию или описанию проекта...",
        "sectionTitle": "Проекты",
        "loading": "Загрузка проектов...",
        "empty": "Проекты не найдены",
        "loadError": "Ошибка загрузки проектов",
        "archived": "Проект архивирован",
        "unarchived": "Проект разархивирован",
        "archiveError": "Ошибка архивирования проекта",
        "unarchiveError": "Ошибка разархивирования проекта",
        "created": "Создан",
        "archivedBadge": "Архивный",
        "activeBadge": "Активный",
        "statsTotal": "Всего проектов",
        "statsActive": "Активных",
        "statsArchived": "Архивных",
        "statsForms": "Форм"
      },
      "forms": {
        "title": "Управление формами",
        "subtitle": "Просмотр и управление всеми формами системы",
        "searchPlaceholder": "Поиск по названию или XML ID формы...",
        "sectionTitle": "Формы",
        "loading": "Загрузка форм...",
        "empty": "Формы не найдены",
        "loadError": "Ошибка загрузки форм",
        "deletedToast": "Форма помечена как удаленная",
        "restoredToast": "Форма восстановлена",
        "deleteError": "Ошибка удаления формы",
        "restoreError": "Ошибка восстановления формы",
        "created": "Создана",
        "deletedBadge": "Удалена",
        "activeBadge": "Активна",
        "importedBadge": "Импортирована",
        "statsTotal": "Всего форм",
        "statsActive": "Активных",
        "statsDeleted": "Удаленных",
        "statsImported": "Импортированных"
      },
      "permissionGroups": {
        "title": "Группы разрешений",
        "subtitle": "Управление группами разрешений и назначение их пользователям",
        "createGroup": "Создать группу",
        "sectionTitle": "Группы разрешений",
        "searchPlaceholder": "Поиск групп...",
        "emptyTitle": "Группы разрешений не найдены",
        "emptyBody": "Создайте первую группу разрешений для начала работы",
        "emptyFilter": "Нет групп по текущему поиску",
        "deleteTitle": "Удаление группы",
        "deleteMessage": "Вы уверены, что хотите удалить группу \"{name}\"? Это действие нельзя отменить.",
        "restoreTitle": "Восстановить",
        "users": "Пользователи",
        "statsTotal": "Всего групп",
        "statsActive": "Активные группы",
        "statsAssignments": "Назначений",
        "loadError": "Ошибка при загрузке групп разрешений",
        "restored": "Группа «{name}» восстановлена",
        "deleted": "Группа разрешений успешно удалена",
        "saved": "Группа разрешений сохранена",
        "restoreError": "Не удалось восстановить группу разрешений",
        "deleteError": "Не удалось удалить группу разрешений",
        "modal": {
          "createTitle": "Создать группу разрешений",
          "editTitle": "Редактировать группу разрешений",
          "createHeader": "Новая группа разрешений",
          "editHeader": "Редактирование группы",
          "createSubtitle": "Создайте новую группу с набором ролей",
          "editSubtitle": "Измените параметры группы разрешений",
          "nameLabel": "Название группы",
          "namePlaceholder": "Введите название группы",
          "descriptionLabel": "Описание",
          "descriptionPlaceholder": "Введите описание группы",
          "activeLabel": "Группа активна",
          "activeHint": "Неактивные группы не могут быть назначены пользователям",
          "rolesTitle": "Роли группы",
          "rolesSubtitle": "Выберите роли, которые будут включены в эту группу",
          "selectAtLeastOneRole": "Выберите хотя бы одну роль",
          "selectedRolesTitle": "Выбранные роли",
          "clickToRemove": "Нажмите на роль, чтобы удалить её из группы",
          "validation": {
            "nameRequired": "Название обязательно",
            "nameMinLength": "Название должно содержать минимум 2 символа",
            "nameMaxLength": "Название не должно превышать 50 символов"
          },
          "toasts": {
            "createSuccess": "Группа разрешений успешно создана",
            "updateSuccess": "Группа разрешений успешно обновлена",
            "saveError": "Ошибка при сохранении группы разрешений"
          }
        },
        "groupUsersModal": {
          "title": "Пользователи группы \"{name}\"",
          "noDescription": "Описание отсутствует",
          "rolesCount": "Ролей в группе: {count}",
          "usersCount": "Пользователи группы ({count})",
          "empty": "В этой группе нет пользователей",
          "noName": "Без имени",
          "active": "Активен",
          "inactive": "Неактивен",
          "superuser": "Суперпользователь",
          "owner": "Владелец",
          "loadError": "Ошибка при загрузке пользователей группы"
        }
      },
      "globalOdkServers": {
        "title": "Управление глобальными ODK серверами",
        "subtitle": "Создание и управление глобальными ODK серверами системы",
        "createServer": "Создать сервер",
        "searchPlaceholder": "Поиск по имени, URL или пользователю...",
        "empty": "Нет глобальных ODK серверов",
        "emptyHint": "Создайте первый глобальный ODK сервер для начала работы.",
        "emptyFilter": "Нет серверов по текущему поиску",
        "defaultBadge": "По умолчанию",
        "statsTotal": "Всего серверов",
        "statsTotalHint": "{count} (+{active} акт.)",
        "statsGlobal": "Глобальных",
        "statsDefault": "По умолчанию",
        "columns": {
          "server": "Сервер",
          "user": "Пользователь",
          "visibility": "Видимость"
        },
        "visibility": {
          "GLOBAL": "Глобальный",
          "ORGANIZATION": "Организация",
          "SHARED": "Общий"
        },
        "actions": {
          "test": "Тест подключения",
          "refreshToken": "Обновить токен",
          "setDefault": "Установить по умолчанию"
        },
        "testTitle": "Результат тестирования подключения",
        "testOk": "Подключение успешно",
        "testFail": "Ошибка подключения",
        "testMethod": "Метод:",
        "testProjects": "Количество проектов:",
        "testing": "Тестирование подключения...",
        "refreshTokenTitle": "Обновить API токен",
        "refreshTokenBody": "Введите пароль для обновления API токена сервера",
        "password": "Пароль",
        "passwordPlaceholder": "Введите пароль",
        "refreshTokenAction": "Обновить токен",
        "requiredField": "Это поле обязательно для заполнения",
        "deleteTitle": "Удалить сервер",
        "deleteMessage": "Удалить сервер \"{name}\"? Это действие нельзя отменить.",
        "setDefaultTitle": "Установить сервер по умолчанию",
        "setDefaultMessage": "Установить сервер \"{name}\" как глобальный сервер по умолчанию?",
        "setDefaultConfirm": "Установить",
        "toastCreated": "Сервер успешно создан",
        "toastUpdated": "Сервер успешно обновлен",
        "toastDeleted": "Сервер успешно удален",
        "toastTestOk": "Подключение к серверу успешно",
        "toastTokenRefreshed": "API токен успешно обновлен",
        "toastDefaultSet": "Глобальный сервер по умолчанию установлен",
        "form": {
          "createTitle": "Создать глобальный ODK сервер",
          "editTitle": "Редактировать глобальный ODK сервер",
          "nameLabel": "Название сервера",
          "namePlaceholder": "Введите название сервера",
          "urlLabel": "URL сервера",
          "urlPlaceholder": "https://example.com",
          "usernameLabel": "Имя пользователя",
          "usernamePlaceholder": "Введите имя пользователя",
          "passwordLabel": "Пароль",
          "passwordPlaceholder": "Введите пароль",
          "descriptionLabel": "Описание",
          "descriptionPlaceholder": "Описание сервера (необязательно)",
          "globalDefaultLabel": "Глобальный сервер по умолчанию",
          "activeLabel": "Активный сервер",
          "updateButton": "Обновить"
        }
      },
      "subscriptions": {
        "title": "Биллинг-подписки",
        "subtitle": "SaaS-биллинг и платёжные планы (не квоты Hermes Agent)",
        "stubBadge": "Скоро",
        "stubBody": "Биллинг и платёжные подписки в разработке. На этой странице появятся коммерческие планы, когда биллинг будет готов.",
        "stubAgentHint": "Тарифы, квоты и флаги функций Hermes Agent управляются в Integrations → Hermes Agent → Subscriptions.",
        "openAgentSubscriptions": "Открыть подписки Agent"
      },
      "audit": {
        "title": "Аудит действий",
        "subtitle": "Журнал административных действий суперпользователей",
        "loadError": "Не удалось загрузить журнал аудита.",
        "empty": "Записей аудита пока нет",
        "emptyFilter": "Нет записей по текущему поиску",
        "searchPlaceholder": "Поиск по пользователю, действию или деталям...",
        "time": "Время",
        "user": "Пользователь",
        "action": "Действие",
        "actionKey": "Ключ действия",
        "details": "Детали",
        "detailTitle": "Запись аудита"
      },
      "system": {
        "title": "Состояние системы",
        "subtitle": "Диагностика инфраструктуры — статус, задержки и runtime-детали",
        "loadError": "Не удалось загрузить состояние системы.",
        "attentionTitle": "Требует внимания",
        "attentionComponent": "{component}: {status}",
        "openAgent": "Открыть Agent",
        "componentsTitle": "Компоненты",
        "serverInfo": "Runtime-детали",
        "version": "Версия",
        "uptime": "Аптайм процесса",
        "dbConnections": "Соединения БД (активные)",
        "dbPool": "Размер пула БД",
        "dbLatency": "Задержка БД",
        "apiLatency": "Задержка API",
        "components": {
          "server": "Сервер",
          "database": "База данных",
          "redis": "Redis",
          "api": "API",
          "agent": "Hermes Agent"
        }
      },
      "analytics": {
        "title": "Аналитическая панель",
        "subtitle": "Комплексная аналитика системы и пользователей",
        "loadError": "Не удалось загрузить аналитику. Показаны нулевые значения.",
        "totalUsers": "Всего пользователей",
        "thisMonth": "+{count} в этом месяце",
        "organizations": "Организаций",
        "growthPct": "{pct}% рост",
        "totalProjects": "Всего проектов",
        "totalForms": "Всего форм",
        "submissions": "отправок",
        "userGrowth": "Рост пользователей (по месяцам)",
        "orgActivity": "Активность организаций (по проектам)",
        "noData": "Нет данных",
        "topOrgs": "Топ организации",
        "projectsCount": "{count} проектов",
        "noOrgs": "Нет организаций",
        "recentActivity": "Последняя активность",
        "noRecent": "Нет недавних действий",
        "systemHealth": "Состояние системы",
        "resources": "Использование ресурсов",
        "orgs": "Организаций",
        "projects": "Проектов",
        "forms": "Форм",
        "health": {
          "api": "API",
          "database": "База данных",
          "redis": "Redis",
          "websocket": "WebSocket",
          "agent": "Hermes Agent"
        }
      },
      "roles": {
        "title": "Роли и разрешения",
        "subtitle": "Каталог платформенных ролей — строительные блоки для групп разрешений",
        "searchPlaceholder": "Поиск ролей...",
        "loadError": "Не удалось загрузить роли.",
        "emptyTitle": "Роли не найдены",
        "emptyFilter": "Нет ролей по текущему поиску",
        "openGroups": "Группы разрешений",
        "system": "Системная",
        "custom": "Пользовательская",
        "unused": "Не используется ни в одной группе",
        "columns": {
          "role": "Роль",
          "description": "Описание",
          "usedIn": "В группах",
          "type": "Тип"
        },
        "labels": {
          "project_member": "Участник проекта"
        },
        "descriptions": {
          "fallback": "Описание недоступно.",
          "manager": "Полное управление проектом и надзор за качеством.",
          "project_member": "Минимальный доступ к проекту — название и формы, без данных отправок.",
          "data_viewer": "Только чтение отправок, мониторинг и просмотр QC.",
          "data_collector": "Сбор и отправка полевых данных.",
          "data_downloader": "Экспорт и скачивание данных отправок.",
          "data_analyst": "Операции QC и аналитика данных.",
          "form_designer": "Создание и управление XLSForm.",
          "qc_editor": "Редактирование результатов и находок QC."
        }
      }
    },
    "dashboard": {
      "title": "Обзор",
      "subtitle": "Состояние платформы и недавние действия администраторов",
      "errors": {
        "stats": "Не удалось загрузить системную статистику. Показаны нулевые значения.",
        "health": "Не удалось загрузить состояние системы.",
        "activities": "Не удалось загрузить последние действия."
      },
      "attention": {
        "title": "Требует внимания",
        "server": "Сервер сообщает о проблемах.",
        "database": "База данных сообщает о проблемах.",
        "redis": "Redis сообщает о проблемах.",
        "api": "API сообщает о проблемах.",
        "agent": "Статус Hermes Agent: {status}.",
        "failedLogins": "{count} неудачных входов за последние 24 часа.",
        "openSystem": "Система",
        "openAgent": "Агент",
        "openAudit": "Аудит"
      },
      "sections": {
        "metrics": "Каталог",
        "health": "Здоровье",
        "activity": "Последние действия"
      },
      "metrics": {
        "users": "Пользователи",
        "usersHint": "+{count} сегодня",
        "orgs": "Организации",
        "orgsHint": "+{count} за неделю",
        "projects": "Проекты",
        "projectsHint": "{count} активных",
        "failedLogins": "Неудачные входы",
        "failedLoginsHint": "За 24 часа"
      },
      "health": {
        "server": "Сервер",
        "database": "База данных",
        "redis": "Redis",
        "api": "API",
        "agent": "Hermes Agent",
        "connections": "{count} соединений",
        "latency": "{ms} мс",
        "agentHint": "{count} req сегодня"
      },
      "activity": {
        "viewAll": "Весь аудит",
        "empty": "Нет недавних действий"
      }
    }
  },
  "agent": {
    "common": {
      "loading": "Загрузка подписки агента...",
      "working": "Агент работает..."
    },
    "features": {
      "reports": "Отчёты",
      "qc": "QC-ассистент",
      "xlsform": "XLSForm",
      "share_links": "Публичные ссылки",
      "auto_reports": "Автоотчёты",
      "qc_rules": "Правила QC"
    },
    "errors": {
      "generic": "Не удалось выполнить запрос к агенту.",
      "endpointNotFound": "Эта функция агента недоступна на текущем backend. Перезапустите dev-сервер (.\\scripts\\dev.ps1).",
      "timeout": "Агент не ответил вовремя. Для XLSForm подождите до 10 минут и попробуйте снова.",
      "featureUnavailable": "Эта функция недоступна на вашем тарифе.",
      "quotaExceeded": "Превышена квота агента за этот период.",
      "disabled": "AI-агент временно отключён.",
      "mcpUnavailable": "Hermes не видит MCP-инструменты udacapi. Нужно зарегистрировать MCP на CT253 (grant-udacapi-mcp.sh) и проверить relay :8101 → backend :8100. См. runbooks/hermes-udacapi-agent-integration.md."
    },
    "quota": {
      "exceededTitle": {
        "monthly": {
          "requests": "Исчерпан месячный лимит запросов",
          "tokens": "Исчерпан месячный лимит токенов"
        },
        "five_hour": {
          "requests": "Исчерпан лимит запросов за 5 часов",
          "tokens": "Исчерпан лимит токенов за 5 часов"
        },
        "weekly": {
          "requests": "Исчерпан недельный лимит запросов",
          "tokens": "Исчерпан недельный лимит токенов"
        }
      },
      "usageLine": "Использовано {used} из {limit}",
      "resetsAt": "Снова доступно {relative} ({absolute})",
      "resetsUnknown": "Попробуйте позже или обратитесь к администратору для увеличения лимита.",
      "viewSubscription": "Подробнее о квотах",
      "sendBlocked": "Квота агента исчерпана — дождитесь сброса лимита.",
      "nearLimit": "Квота агента почти исчерпана ({pct}%)."
    },
    "upgrade": {
      "lockedTitle": "Функция недоступна",
      "lockedDescription": "«{feature}» доступна на тарифе {tier} и выше."
    },
    "subscription": {
      "sectionTitle": "Агент ИИ UDA",
      "sectionDescription": "Тариф, квоты и доступные функции агента для вашей организации.",
      "currentTier": "Текущий тариф",
      "active": "Активна",
      "inactive": "Неактивна",
      "features": "Доступные функции",
      "tier": "Тариф",
      "capabilities": "Возможности",
      "billingPeriod": "Начало расчётного периода",
      "requests": "Запросы за период",
      "requests_5h": "Запросы (за последние 5ч)",
      "requests_weekly": "Запросы (за неделю)",
      "requests_badge": "запр.",
      "requests_5h_badge": "запр. (5ч)",
      "requests_weekly_badge": "запр. (нед.)",
      "tokens": "Токены за период",
      "tokens_5h": "Токены (за последние 5ч)",
      "tokens_weekly": "Токены (за неделю)",
      "nearQuotaTitle": "Квота почти исчерпана",
      "nearQuotaDescription": "Использовано более 80% месячной квоты. Обратитесь к администратору для повышения лимита.",
      "tiers": {
        "free": "Бесплатный",
        "pro": "Pro",
        "enterprise": "Корпоративный"
      },
      "trialActive": "Пробный Pro до {date}. Затем остаётесь на Free с лимитами плана.",
      "submissionsSoftExceeded": "Объём submissions выше мягкого лимита плана. Свяжитесь с нами для апгрейда — синхронизация поля не блокируется."
    },
    "report": {
      "title": "AI-отчёт для PM",
      "description": "Сводка по submissions, подготовленная AI-агентом UDA.",
      "period": "Период (дней)",
      "generate": "Сгенерировать отчёт",
      "generating": "Агент готовит отчёт...",
      "empty": "Нажмите «Сгенерировать отчёт», чтобы получить сводку.",
      "modeSummary": "Краткий",
      "modeAnalytical": "Аналитический",
      "modeScheduled": "По шаблону",
      "quotaExceeded": "Превышена квота агента за этот период.",
      "featureUnavailable": "AI-отчёты недоступны на вашем тарифе.",
      "error": "Не удалось получить отчёт от агента.",
      "healthAlerts": "Замечания по состоянию формы",
      "copy": "Копировать отчёт",
      "copied": "Скопировано",
      "copyFailed": "Не удалось скопировать в буфер обмена.",
      "viewFormatted": "Форматированный",
      "viewRaw": "Markdown",
      "auto": {
        "latest": "Последний",
        "history": "История",
        "generateNow": "Сгенерировать сейчас",
        "manageTemplates": "Управление шаблонами",
        "selectTemplate": "Шаблон",
        "latestEmpty": "Пока нет готовых отчётов по шаблонам. Выберите шаблон и нажмите «Сгенерировать сейчас».",
        "historyEmpty": "Пока нет запусков отчётов.",
        "view": "Открыть",
        "viewTitle": "Отчёт",
        "close": "Закрыть",
        "generating": "Генерация отчёта по шаблону...",
        "done": "Отчёт готов.",
        "statusLabel": "Статус: {status}",
        "emptyResult": "Отчёт завершился, но без содержимого.",
        "runFailed": "Не удалось сформировать отчёт.",
        "timeout": "Отчёт занял слишком много времени. Попробуйте позже.",
        "noContent": "Содержимое отчёта недоступно.",
        "unknownTemplate": "Неизвестный шаблон",
        "trigger": {
          "scheduled": "По расписанию",
          "event": "Событие",
          "manual": "Вручную"
        },
        "status": {
          "pending": "Ожидание",
          "running": "Выполняется",
          "done": "Готово",
          "failed": "Ошибка"
        }
      },
      "templates": {
        "title": "Шаблоны отчётов",
        "subtitle": "Настройка расписания и промптов AI-отчётов для организации.",
        "create": "Новый шаблон",
        "createTitle": "Создать шаблон отчёта",
        "edit": "Изменить",
        "editTitle": "Редактировать шаблон",
        "formSubtitle": "Определите содержание отчёта, расписание запуска и получателей.",
        "sections": {
          "content": "Содержание отчёта",
          "schedule": "Расписание",
          "delivery": "Доставка и охват"
        },
        "seed": "Загрузить defaults",
        "seeded": "Добавлено шаблонов: {count}.",
        "empty": "Шаблонов пока нет. Загрузите defaults или создайте новый.",
        "active": "Активен",
        "inactive": "Неактивен",
        "cron": "Расписание",
        "sendByEmail": "Отправлять на email",
        "deactivate": "Деактивировать",
        "deactivated": "Шаблон деактивирован.",
        "activate": "Активировать",
        "activated": "Шаблон активирован.",
        "save": "Сохранить",
        "saved": "Шаблон сохранён.",
        "saveError": "Не удалось сохранить шаблон.",
        "loadError": "Не удалось загрузить шаблоны отчётов.",
        "validationRequired": "Нужны имя и промпт.",
        "recipientsPlaceholder": "Выберите участников организации",
        "recipientsRequired": "Выберите хотя бы одного получателя, если включена отправка на email.",
        "promptHint": "Доступ к данным организации, выбранным формам и периоду добавляется автоматически.",
        "allFormsPlaceholder": "Все формы (оставьте пустым)",
        "advancedMode": "Свой промпт (расширенный, Jinja2)",
        "fields": {
          "name": "Название",
          "audience": "Аудитория",
          "prompt": "Инструкции для отчёта",
          "responseLanguage": "Язык ответа",
          "recipients": "Получатели",
          "formScope": "Формы"
        },
        "schedule": {
          "label": "Расписание",
          "none": "Без расписания",
          "daily": "Ежедневно",
          "weekly": "Еженедельно",
          "monthly": "Ежемесячно",
          "custom": "Свой (cron)",
          "time": "Время",
          "weekday": "День недели",
          "dayOfMonth": "Число месяца",
          "customCron": "Cron-выражение",
          "humanDaily": "Ежедневно в {time}",
          "humanWeekly": "Каждый(ая) {weekday} в {time}",
          "humanMonthly": "Ежемесячно {day}-го числа в {time}",
          "weekdays": {
            "0": "Воскресенье",
            "1": "Понедельник",
            "2": "Вторник",
            "3": "Среда",
            "4": "Четверг",
            "5": "Пятница",
            "6": "Суббота"
          }
        },
        "audience": {
          "pm": "Менеджер проекта",
          "field_coord": "Полевой координатор",
          "statistician": "Статистик",
          "executive": "Руководство"
        }
      }
    },
    "chat": {
      "modeAsk": "Спросить агента",
      "description": "Задавайте вопросы о схеме формы, submissions, аналитике, правилах QC и статусе синхронизации. Ответы основаны на актуальных данных; в примерах submissions могут быть персональные поля.",
      "question": "Ваш вопрос",
      "placeholder": "Например: сколько submissions за последние 7 дней? Какие поля есть в форме?",
      "send": "Отправить",
      "empty": "Задайте вопрос о данных этой формы.",
      "you": "Вы",
      "agent": "Агент",
      "generating": "Агент запрашивает данные формы...",
      "sendHint": "Enter — отправить · Shift+Enter — новая строка"
    },
    "analytical": {
      "generate": "Запустить аналитический отчёт",
      "empty": "Запустите аналитический отчёт для глубокого анализа данных формы.",
      "queued": "Отчёт поставлен в очередь...",
      "status": "Статус: {status}",
      "done": "Отчёт готов.",
      "failed": "Не удалось сформировать аналитический отчёт.",
      "emptyResult": "Отчёт завершился, но без содержимого.",
      "timeout": "Аналитический отчёт занял слишком много времени. Проверьте, что запущен agent-reports-worker.",
      "workerHint": "Задача всё ещё в очереди. Запустите сервис agent-reports-worker (docker compose up -d agent-reports-worker) и повторите запрос."
    },
    "qc": {
      "title": "AI-помощник QC",
      "description": "Опишите проверку на естественном языке — агент предложит черновик правила.",
      "checkDescription": "Описание проверки",
      "checkPlaceholder": "Например: возраст респондента должен быть от 18 до 65 лет",
      "suggest": "Предложить правило",
      "generating": "Агент готовит черновик правила...",
      "applyDraft": "Применить черновик к форме",
      "draftApplied": "Черновик применён к форме правила.",
      "draftPreview": "Предложенное правило",
      "viewRawResponse": "Показать полный ответ агента",
      "sendHint": "Enter — предложить · Shift+Enter — новая строка",
      "noDraftParsed": "Не удалось распознать JSON черновика в ответе агента.",
      "validationWarnings": "Замечания валидации ({count}):",
      "starterPack": {
        "title": "Стартовый набор QC",
        "description": "Агент просмотрит форму и предложит набор правил для начала валидации.",
        "focus": "Фокус",
        "focusAll": "Сбалансированный набор",
        "focusRequired": "Только обязательные поля",
        "focusConstraints": "Только ограничения",
        "maxRules": "Макс. правил",
        "suggest": "Предложить стартовый набор",
        "generating": "Анализ формы и подготовка правил...",
        "apply": "Применить правило",
        "empty": "Валидных черновиков не получено. Повторите запрос или используйте одиночное предложение выше.",
        "skippedHint": "Пропущено предложений: {count} (дубликат, невалидно или сверх лимита)."
      }
    },
    "xlsform": {
      "openButton": "AI XLSForm",
      "title": "AI-ассистент XLSForm",
      "description": "Загрузите файл с вопросами или опишите задачу — агент подготовит черновик, протестирует и предложит публикацию.",
      "instruction": "Инструкция для агента",
      "instructionPlaceholder": "Например: создай форму опроса удовлетворённости с 5 вопросами",
      "empty": "Опишите нужную форму или загрузите файл — агент подготовит и протестирует черновик.",
      "send": "Отправить",
      "sendHint": "Enter — отправить · Shift+Enter — новая строка",
      "working": "Агент выполняет задачу...",
      "you": "Вы",
      "agent": "Агент",
      "publishTitle": "Подтверждение публикации",
      "publishDescription": "Агент запросил публикацию черновика. Подтвердите вручную — публикация без подтверждения невозможна.",
      "formId": "ID формы (xmlFormId)",
      "versionOptional": "Версия (необязательно)",
      "confirmPublish": "Подтвердить публикацию",
      "upload": {
        "hint": "Прикрепите Excel/CSV, Word или текст со списком вопросов (до 5 МБ)",
        "attachAria": "Прикрепить файл",
        "removeAttachment": "Убрать вложение",
        "selected": "Файл: {name}",
        "attachmentPrefix": "[файл: {name}]"
      },
      "session": {
        "resumeBanner": "Есть незавершённая сессия AI XLSForm (черновик: {formId})",
        "resumeButton": "Продолжить",
        "startNewButton": "Начать заново",
        "dismissButton": "Скрыть",
        "dismissError": "Не удалось закрыть сессию. Попробуйте снова.",
        "historyButton": "Прошлые сессии",
        "historyAriaLabel": "История сессий",
        "historyTitle": "Сессии AI XLSForm",
        "historyHint": "Сессии за последние 7 дней. Продолжите черновик или просмотрите опубликованную сессию.",
        "historyEmpty": "Нет прошлых сессий для этого проекта.",
        "historyFormColumn": "Черновик формы",
        "historyStatusColumn": "Статус",
        "historyUpdatedColumn": "Обновлено",
        "historyPreviewColumn": "Последнее примечание",
        "historyMessagesColumn": "Сообщения",
        "historyActionsColumn": "Действия",
        "continueButton": "Продолжить",
        "viewButton": "Просмотр",
        "clearDismissedButton": "Очистить скрытые",
        "clearFailedButton": "Очистить с ошибкой",
        "clearNonPublishedButton": "Очистить все неопубликованные",
        "continueError": "Не удалось возобновить сессию. Попробуйте снова.",
        "cleanupError": "Не удалось очистить прошлые сессии. Попробуйте снова.",
        "forkedFrom": "Форк предыдущей версии",
        "lineagePublished": "Опубликованная версия",
        "cleanupConfirm": {
          "dismissed": {
            "title": "Очистить скрытые сессии?",
            "message": "Скрытые сессии этого проекта будут удалены навсегда. Опубликованные останутся."
          },
          "failed": {
            "title": "Очистить сессии с ошибкой?",
            "message": "Сессии с ошибкой для этого проекта будут удалены навсегда."
          },
          "non_published": {
            "title": "Очистить все неопубликованные сессии?",
            "message": "Будут удалены активные, скрытые и сессии с ошибкой. Опубликованные останутся."
          }
        },
        "readOnlyHint": "Сессия опубликована. Можно просмотреть историю чата, но нельзя отправлять новые сообщения.",
        "draftUnknown": "без имени",
        "status": {
          "active": "Активная",
          "discarded": "Скрыта",
          "failed": "Ошибка",
          "published": "Опубликована"
        }
      },
      "job": {
        "canClose": "Можно закрыть окно — сессия продолжится в фоне.",
        "elapsed": "Работаем… {time}",
        "agentWorking": "Агент обрабатывает запрос (LLM и MCP-инструменты). Этот шаг может занять несколько минут.",
        "longWait": "Всё ещё работаем — если прошло больше 10 минут, проверьте LLM-прокси и MCP-relay Hermes.",
        "timeout": "Ассистент не успел завершить задачу. Неудачная сессия сброшена; повторите запрос в новой сессии.",
        "failed": "Не удалось выполнить задачу. Попробуйте снова.",
        "phases": {
          "queued": "В очереди",
          "planning": "Анализ запроса",
          "editing": "Редактирование вопросов формы",
          "uploading_draft": "Создание черновика формы",
          "testing_draft": "Тестовая отправка",
          "finalizing": "Подготовка ответа",
          "completed": "Готово"
        },
        "queuedFallback": "Воркер ещё не взял задачу — сервер скоро запустит её в процессе API."
      },
      "preview": {
        "tabChat": "Чат",
        "tabPreview": "Предпросмотр",
        "loading": "Загрузка предпросмотра формы…",
        "empty": "Пока нет черновика для предпросмотра. Попросите ассистента создать или изменить форму.",
        "error": "Не удалось загрузить предпросмотр формы.",
        "submitError": "Не удалось отправить тестовую отправку."
      },
      "workbench": {
        "tabChat": "Чат",
        "tabPreview": "Предпросмотр",
        "downloadDraft": "Скачать черновик",
        "downloadPublished": "Скачать опубликованную",
        "uploadExcel": "Загрузить Excel",
        "uploadConfirmTitle": "Заменить форму из Excel?",
        "uploadConfirmMessage": "Текущие вопросы черновика будут заменены загруженной таблицей.",
        "uploadConfirmDetail": "История чата с ассистентом сохранится; изменится только структура формы.",
        "startRevision": "Начать ревизию",
        "openForm": "Открыть форму в проекте",
        "downloadError": "Не удалось скачать Excel-файл.",
        "importError": "Не удалось импортировать Excel-файл.",
        "forkError": "Не удалось начать сессию ревизии."
      },
      "settings": {
        "title": "Настройки формы",
        "hint": "Form ID станет xmlFormId в ODK. Он должен быть уникален в проекте. После публикации менять его не рекомендуется.",
        "formTitle": "Название формы",
        "formId": "Form ID (xmlFormId)",
        "save": "Сохранить настройки",
        "saved": "Настройки сохранены",
        "conflict": "Этот Form ID уже используется в проекте.",
        "suggestion": "Попробуйте: {id}",
        "saveError": "Не удалось сохранить настройки формы.",
        "saveBusy": "Не удалось сохранить, пока агент держит черновик. Дождитесь окончания задания или попробуйте снова."
      },
      "header": {
        "newForm": "Новая форма",
        "version": "Спека v{version}",
        "status": {
          "idea": "Планирование",
          "draft": "Черновик готов",
          "publish": "Ожидает публикации",
          "published": "Опубликована",
          "conflict": "Требует внимания",
          "failed": "Ошибка"
        }
      },
      "timeline": {
        "title": "Системные события"
      },
      "changes": {
        "title": "Сводка изменений"
      },
      "validation": {
        "title": "Проверка",
        "empty": "Проверка появится после первого изменения черновика.",
        "noIssues": "Блокирующих проблем не найдено.",
        "applySuggestedId": "Применить предложенный ID",
        "editSettings": "Изменить настройки",
        "status": {
          "ok": "ОК",
          "warning": "Предупреждение",
          "error": "Ошибка"
        }
      },
      "recovery": {
        "retryLast": "Повторить последний запрос",
        "startFresh": "Новая сессия"
      }
    },
    "entitlement": {
      "title": "Требуется апгрейд",
      "body": "Эта возможность не входит в текущий план организации. Свяжитесь с нами, чтобы перейти на Pro или Enterprise.",
      "contactUs": "Свяжитесь с нами для апгрейда плана."
    }
  },
  "websocket": {
    "notifications": {
      "syncComplete": "Синхронизация завершена: {formName}. Обработано {count} из {total} записей",
      "syncError": "Ошибка синхронизации: {formName}. {error}",
      "formStatusChange": "Статус формы изменён: {formName} ({oldStatus} → {newStatus})",
      "schedulerUpdate": "Планировщик: {status}. Активных задач: {activeJobs}/{totalJobs}",
      "qcValidationComplete": "QC валидация завершена: {instanceId}. Правил: {totalRules}, прошло: {passedRules}, ошибок: {errorRules}, предупреждений: {warningRules}",
      "projectStatusSummary": "Критические изменения: {errorProjects} проектов с ошибками, {errorForms} форм с ошибками из {totalProjects} проектов и {totalForms} форм"
    },
    "connection": {
      "connected": "WebSocket подключён",
      "disconnected": "WebSocket отключён",
      "reconnecting": "Переподключение...",
      "error": "Ошибка WebSocket: {error}",
      "maxRetriesReached": "Достигнуто максимальное количество попыток переподключения"
    },
    "connected": "Подключён",
    "disconnected": "Отключён",
    "realTimeUpdates": "Обновления в реальном времени"
  },
  "buttonSelect": {
    "dark": "Тёмная",
    "light": "Светлая"
  },
  "odkOptions": {
    "themes": {
      "light": "Светлая",
      "dark": "Тёмная"
    },
    "navigation": {
      "swipe": "Свайпы",
      "buttons": "Кнопки",
      "swipe_buttons": "Свайпы + Кнопки"
    },
    "formUpdate": {
      "manual": "Вручную",
      "previously_downloaded": "Ранее скачанные",
      "match_exactly": "Точное соответствие"
    },
    "periodicUpdates": {
      "every_fifteen_minutes": "Каждые 15 минут",
      "every_one_hour": "Каждый час",
      "every_six_hours": "Каждые 6 часов",
      "every_24_hours": "Каждые 24 часа"
    },
    "autosend": {
      "off": "Выкл",
      "wifi_only": "Только Wi‑Fi",
      "cellular_only": "Только мобильная сеть",
      "wifi_and_cellular": "Wi‑Fi и мобильная сеть"
    },
    "constraintBehavior": {
      "on_swipe": "При свайпе",
      "on_finalize": "При финализации"
    },
    "imageSizes": {
      "original": "Оригинал",
      "very_small": "Очень маленький",
      "small": "Маленький",
      "medium": "Средний",
      "large": "Большой"
    },
    "guidanceHint": {
      "no": "Нет",
      "yes": "Да",
      "yes_collapsed": "Да (свёрнуто)"
    },
    "basemap": {
      "google": "Google",
      "mapbox": "Mapbox",
      "osm": "OSM",
      "usgs": "USGS",
      "carto": "Carto"
    },
    "mapStyles": {
      "normal": "Нормальный",
      "terrain": "Рельеф",
      "hybrid": "Гибрид",
      "satellite": "Спутник",
      "light": "Светлый",
      "dark": "Тёмный",
      "satellite_streets": "Спутник + улицы",
      "outdoors": "На улице",
      "topographic": "Топографический",
      "positron": "Positron",
      "dark_matter": "Тёмная материя"
    },
    "fontSizes": {
      "small": "Маленький",
      "normal": "Нормальный",
      "large": "Большой",
      "xl": "Очень большой (XL)",
      "xxl": "Огромный (XXL)"
    }
  },
  "users": {
    "title": "Управление пользователями",
    "subtitle": "Управляйте пользователями организации, фильтруйте по активности и обновляйте регистрацию доступа.",
    "searchUser": "Поиск пользователя",
    "addUser": "Добавить пользователя",
    "editUser": "Редактировать пользователя",
    "deleteUser": "Удалить пользователя",
    "firstName": "Имя",
    "lastName": "Фамилия",
    "fullName": "Полное имя",
    "email": "Email",
    "password": "Пароль",
    "confirmPassword": "Подтвердите пароль",
    "enterEmail": "Введите email",
    "userCreated": "Пользователь создан успешно",
    "userUpdated": "Пользователь обновлен успешно",
    "userDeleted": "Пользователь удален успешно",
    "confirmDeleteUser": "Вы уверены, что хотите удалить этого пользователя?",
    "projectSelection": {
      "archived": "Архивный",
      "noProjects": "Нет доступных проектов",
      "noProjectsDescription": "В организации нет проектов для назначения разрешений",
      "errorLoadingProjects": "Ошибка загрузки проектов"
    },
    "admin": "Администратор",
    "data_collector": "Сборщик данных",
    "supervisor": "Супервизор",
    "user": "Пользователь",
    "owner": "Владелец",
    "isClient": "Клиент",
    "active": "Активен",
    "inactive": "Неактивен",
    "refresh": "Обновить",
    "unsavedChanges": "У вас есть несохранённые изменения. Вы уверены, что хотите закрыть форму?",
    "validation": {
      "passwordRequired": "Пароль обязателен",
      "passwordMinLength": "Пароль должен содержать минимум 8 символов",
      "confirmPasswordRequired": "Подтверждение пароля обязательно",
      "passwordsDontMatch": "Пароли не совпадают"
    },
    "editUserDescription": "Измените данные пользователя",
    "addUserDescription": "Создайте нового пользователя в системе",
    "basicInformation": "Основная информация",
    "fullNamePlaceholder": "Введите полное имя",
    "passwordSettings": "Настройка пароля",
    "passwordPlaceholder": "Введите пароль",
    "confirmPasswordPlaceholder": "Подтвердите пароль",
    "passwordHelp": "Пароль должен содержать минимум 8 символов",
    "userSettings": "Настройки пользователя",
    "clientUserDescription": "Клиентский пользователь имеет ограниченный доступ",
    "inactiveUserDescription": "Неактивные пользователи не могут войти в систему",
    "noName": "Без имени"
  },
  "user": {
    "system": "Система",
    "account": "Аккаунт",
    "explore": "Обзор",
    "profile": "Профиль",
    "logout": "Выйти",
    "settings": "Настройки",
    "projects": "Проекты",
    "faq": "Справка",
    "help": "Справка",
    "helpAndSupport": "Помощь и поддержка",
    "administration": "Администрация"
  },
  "odkSync": {
    "dashboard": {
      "title": "Панель синхронизации ODK"
    },
    "workbench": {
      "contextHint": "Контроль загрузки данных с ODK-серверов и управление курсорами синхронизации в организации.",
      "live": "Обновления в реальном времени",
      "reconnect": "Переподключить",
      "loading": "Загрузка данных синхронизации…",
      "schedulerPill": "Планировщик",
      "schedulerActive": "Активен",
      "schedulerPaused": "На паузе",
      "schedulerStopped": "Остановлен",
      "statusLive": "В сети",
      "statusOffline": "Не в сети",
      "statusSchedulerActive": "Активен",
      "statusSchedulerPaused": "На паузе",
      "statusSchedulerStopped": "Остановлен",
      "createShort": "Новый",
      "pipeline": {
        "ariaLabel": "Статус конвейера синхронизации",
        "scheduler": "Планировщик",
        "schedulerActive": "Работает по расписанию",
        "schedulerPaused": "На паузе — новые ответы не синхронизируются",
        "pull": "Последняя загрузка",
        "cursors": "Курсоры",
        "cursorsHint": "Отслеживается форм: {count}",
        "cursorsEmpty": "Курсоры ещё не созданы"
      }
    },
    "table": {
      "emptyState": "Курсоров синхронизации пока нет. Создайте курсор, чтобы начать загрузку ответов."
    },
    "scheduler": {
      "title": "Планировщик синхронизации",
      "pauseScheduler": "Приостановить планировщик",
      "resumeScheduler": "Возобновить планировщик",
      "pausedMessage": "Синхронизация данных ODK в настоящее время приостановлена. Новые отправления не будут синхронизированы до возобновления."
    },
    "managerScope": {
      "title": "Просмотр данных синхронизации",
      "message": "Вы просматриваете данные синхронизации для {count} проектов, которые вы управляете. Вы можете видеть и управлять синхронизацией только для проектов, где у вас есть роль менеджера."
    },
    "statistics": {
      "title": "Статистика синхронизации",
      "totalCursors": "Всего курсоров",
      "lastSync": "Последняя синхронизация"
    },
    "cursors": {
      "title": "Курсоры синхронизации",
      "viewModes": {
        "cards": "Карточки",
        "table": "Таблица",
        "projects": "По проектам",
        "list": "Список"
      },
      "actions": {
        "clear": "Очистить",
        "bulkSync": "Массовая синхронизация ({count})",
        "bulkReset": "Массовый сброс ({count})",
        "createCursor": "Создать курсор"
      }
    },
    "auto": {
      "managed": "Авто",
      "manual": "Ручной",
      "enableAuto": "Включить авто ({count})",
      "disableAuto": "Отключить авто ({count})",
      "reason": "Причина",
      "reasons": {
        "importedActive": "Импорт активной формы",
        "createdActive": "Создание активной формы",
        "uploadedActive": "Загрузка активной формы",
        "formOpened": "Форма открыта",
        "formClosed": "Форма закрыта",
        "formReopened": "Форма переоткрыта",
        "newFormOpened": "Новая форма открыта",
        "migrated": "Мигрировано",
        "formNotFound": "Форма не найдена",
        "manualOverride": "Ручное управление",
        "formDeleted": "Форма удалена",
        "importedFormDeleted": "Импортированная форма удалена"
      }
    },
    "projectSummary": {
      "forms": "Форм: {count}",
      "lastSync": "Последняя синхронизация",
      "active": "Активных: {count}",
      "errors": "Ошибок: {count}",
      "inactive": "Неактивных: {count}",
      "noProjects": "Нет проектов",
      "createFirstCursor": "Создайте первый курсор синхронизации"
    },
    "projectResponsible": {
      "responsible": "Ответственный",
      "notAssigned": "Не назначен",
      "assign": "Назначить",
      "remove": "Убрать",
      "assignModal": {
        "title": "Назначить ответственного для проекта \"{project}\"",
        "selectUser": "Выберите пользователя",
        "selectUserPlaceholder": "Выберите ответственного",
        "assign": "Назначить",
        "noUsers": "Нет доступных пользователей",
        "noUsersMessage": "В организации нет пользователей для назначения ответственным за проект."
      }
    },
    "modals": {
      "createCursor": {
        "title": "Создать курсор синхронизации",
        "server": "Сервер",
        "project": "Проект",
        "xmlForm": "XML Форма",
        "serverPlaceholder": "Выберите сервер",
        "projectPlaceholder": "Выберите проект",
        "xmlFormPlaceholder": "Выберите форму"
      },
      "manualSync": {
        "title": "Ручная синхронизация",
        "selectCursors": "Выбрать курсоры",
        "forceFullSync": "Принудительная полная синхронизация",
        "maxConcurrent": "Максимум одновременных синхронизаций",
        "startSync": "Начать синхронизацию"
      }
    },
    "messages": {
      "schedulerPaused": "Планировщик синхронизации ODK приостановлен",
      "schedulerResumed": "Планировщик синхронизации ODK возобновлен",
      "cursorCreated": "Курсор синхронизации успешно создан",
      "manualSyncTriggered": "Ручная синхронизация успешно запущена",
      "cursorReset": "Курсор успешно сброшен",
      "bulkResetSuccess": "Успешно сброшено {count} курсоров",
      "selectCursorsForSync": "Пожалуйста, выберите хотя бы один курсор для синхронизации",
      "never": "Никогда"
    },
    "errors": {
      "failedToLoadSyncData": "Не удалось загрузить данные синхронизации",
      "failedToControlScheduler": "Не удалось управлять планировщиком",
      "failedToCreateCursor": "Не удалось создать курсор синхронизации",
      "failedToTriggerManualSync": "Не удалось запустить ручную синхронизацию",
      "failedToResetCursor": "Не удалось сбросить курсор",
      "failedToResetSomeCursors": "Не удалось сбросить некоторые курсоры"
    },
    "filters": {
      "showAllForms": "Показать все курсоры",
      "filteringTitle": "Фильтрация курсоров",
      "filteringMessage": "Показано {filtered} из {total} курсоров. Скрыто {hidden} неактивных курсоров."
    },
    "formStatus": {
      "title": "Статус форм и оптимизация",
      "checkStatuses": "Проверить статусы",
      "statusLabels": {
        "open": "Открытые",
        "closing": "Закрываются",
        "closed": "Закрытые",
        "unknown": "Неизвестно"
      },
      "cards": {
        "title": "Статус форм",
        "description": "Проверка и оптимизация курсоров",
        "refresh": "Обновить"
      },
      "loading": "Загрузка...",
      "autoCheckInterval": "5 минут",
      "lastCheck": "Автоматически каждые 5 минут",
      "benefits": {
        "autoDisable": "Автоматическое отключение курсоров для закрытых форм",
        "resourceOptimization": "Оптимизация ресурсов синхронизации",
        "performanceImprovement": "Улучшенная производительность"
      },
      "messages": {
        "checkStarted": "Проверка статуса форм запущена",
        "checkError": "Ошибка при проверке статуса форм",
        "enableError": "Ошибка при включении курсоров",
        "disableError": "Ошибка при отключении курсоров"
      }
    }
  },
  "odkQc": {
    "dashboard": {
      "title": "QC Dashboard - Качество данных ODK",
      "description": "Мониторинг качества данных ODK submissions с помощью правил валидации"
    },
    "statistics": {
      "totalRules": "Всего правил",
      "activeRules": "Активных правил",
      "inactiveRules": "Неактивных правил",
      "recentValidations": "Последних проверок"
    },
    "sections": {
      "rulesByType": "Правила по типу",
      "rulesBySeverity": "Правила по уровню серьезности",
      "qcRules": "QC Правила"
    },
    "filters": {
      "allTypes": "Все типы",
      "allLevels": "Все уровни",
      "allStatuses": "Все статусы",
      "active": "Активные",
      "inactive": "Неактивные"
    },
    "actions": {
      "createRule": "Создать правило",
      "activate": "Активировать",
      "deactivate": "Деактивировать",
      "clearSelection": "Очистить выбор"
    },
    "ruleTypes": {
      "required": "Обязательное",
      "constraint": "Ограничение",
      "calculation": "Вычисление",
      "custom": "Пользовательское"
    },
    "severityLevels": {
      "error": "Ошибка",
      "warning": "Предупреждение",
      "info": "Информация"
    },
    "messages": {
      "noRuleTypeData": "Нет данных о типах правил",
      "noSeverityData": "Нет данных о уровнях серьезности",
      "ruleUpdated": "Правило обновлено",
      "ruleCreated": "Правило создано",
      "ruleSaveError": "Ошибка сохранения правила",
      "ruleLoadError": "Ошибка загрузки правила",
      "ruleStatusToggled": "Статус правила изменен",
      "ruleStatusError": "Ошибка изменения статуса правила",
      "confirmDeleteRule": "Вы уверены, что хотите удалить это правило?",
      "ruleDeleted": "Правило удалено",
      "ruleDeleteError": "Ошибка удаления правила",
      "ruleSaved": "Правило сохранено",
      "bulkStatusToggled": "Статус изменен для {count} правил",
      "bulkStatusError": "Ошибка изменения статуса правил",
      "bulkDeleted": "Удалено {count} правил",
      "bulkDeleteError": "Ошибка удаления правил",
      "rulesDeleted": "Правила удалены",
      "rulesActivated": "Правила активированы",
      "rulesDeactivated": "Правила деактивированы",
      "ruleNotFound": "Правило не найдено",
      "invalidJsonFormat": "Неверный формат JSON",
      "createExpressionFirst": "Сначала создайте выражение",
      "previewError": "Ошибка предпросмотра",
      "invalidRuleExpression": "Неверное выражение правила",
      "ruleNotExecuted": "Правило не выполнено",
      "loadingRule": "Загрузка правила...",
      "saving": "Сохранение...",
      "loading": "Загрузка...",
      "run": "Запустить",
      "passed": "Прошло",
      "failed": "Не прошло",
      "success": "Успех",
      "errorDuringValidation": "Ошибка во время валидации",
      "noQcRulesFound": "QC правила не найдены"
    },
    "form": {
      "ruleName": "Название правила",
      "ruleNameRequired": "Название правила обязательно",
      "fieldPath": "Основное поле",
      "fieldPathRequired": "Основное поле обязательно",
      "fieldPathHint": "Главное поле, которое проверяет это правило. В JSONLogic выражении можно использовать другие поля.",
      "errorMessage": "Сообщение об ошибке",
      "errorMessageHint": "Показывается проверяющим, когда submission не проходит это правило.",
      "errorMessageRequired": "Сообщение об ошибке обязательно",
      "constraintExpression": "Выражение ограничения",
      "constraintExpressionHint": "Используйте '{'\"var\": \"field_name\"'}' для ссылки на поля submission. Нажмите «Применить» для проверки JSON.",
      "constraintExpressionRequired": "Выражение ограничения обязательно",
      "ruleType": "Тип правила",
      "severityLevel": "Уровень серьезности",
      "ruleActive": "Правило активно",
      "ruleActiveHint": "Неактивные правила сохраняются, но не применяются при проверке.",
      "basicSettings": "Основные настройки",
      "jsonLogicBuilder": "JSONLogic-редактор",
      "jsonLogicBuilderHint": "Определите, когда правило считается выполненным. Выражение должно возвращать true для корректных submission.",
      "reset": "Сбросить",
      "apply": "Применить",
      "saveChanges": "Сохранить изменения",
      "createRule": "Создать правило",
      "editRule": "Редактировать правило",
      "rulePreview": "Предпросмотр правила",
      "testRuleOnSample": "Тестировать правило на выборке данных",
      "detailedResults": "Детальные результаты",
      "showSubmissionData": "Показать данные submission",
      "help": "Справка",
      "ruleTypes": "Типы правил",
      "severityLevels": "Уровни серьезности",
      "requiredField": "Поле должно быть заполнено",
      "constraintCheck": "Проверка по условию",
      "calculatedField": "Вычисляемое поле",
      "customLogic": "Кастомная логика",
      "blocksSubmission": "Блокирует отправку",
      "showsWarning": "Показывает предупреждение",
      "informationalMessage": "Информационное сообщение",
      "jsonLogicExamplesTitle": "Примеры выражений",
      "agreementCheckExample": "Проверка согласия:",
      "finalStatusCheckExample": "Проверка финального статуса:",
      "enumeratorCheckExample": "Проверка перечислителя:",
      "complexLogicExample": "Сложная логика:",
      "fieldValue": "Значение поля",
      "previewStatsLine": "{passed} прошло · {failed} не прошло · {rate}%"
    },
    "placeholders": {
      "searchByNameFieldMessage": "Поиск по названию, полю или сообщению...",
      "ruleType": "Тип правила",
      "severityLevel": "Уровень серьезности",
      "status": "Статус",
      "enterRuleName": "Введите название правила",
      "enterErrorMessage": "Введите сообщение об ошибке",
      "respondentAge": "respondent.age"
    },
    "table": {
      "ariaLabels": {
        "disableRule": "Отключить правило",
        "enableRule": "Включить правило"
      }
    },
    "viewModes": {
      "cards": "Карточки",
      "table": "Таблица"
    }
  },
  "odkCleanup": {
    "page": {
      "title": "Мониторинг очистки данных ODK",
      "subtitle": "Мониторинг системы автоматической очистки и просмотр статистики данных",
      "selectFormTitle": "Выберите форму для мониторинга очистки",
      "currentProject": "Текущий проект",
      "searchPlaceholder": "Поиск и выбор формы...",
      "systemInfo": {
        "title": "Система автоматической очистки",
        "activeFormsTitle": "Активные формы (open/closing)",
        "activeFormsDesc": "Автоматически оставляются только 5 последних папок. Очистка происходит при каждой синхронизации.",
        "closedFormsTitle": "Закрытые формы (closed)",
        "closedFormsDesc": "При закрытии формы автоматически архивируются 4 папки, остается 1 для статистики.",
        "monitoringTitle": "Мониторинг",
        "monitoringDesc": "Выберите форму выше для просмотра статистики и мониторинга работы системы очистки."
      }
    },
    "manager": {
      "title": "Менеджер очистки данных ODK",
      "loading": "Загрузка данных очистки...",
      "noData": {
        "title": "Данные отсутствуют",
        "meaning": "Что это значит:",
        "noSubmissions": "У этой формы еще нет отправок",
        "noSync": "Форма еще не была синхронизирована из ODK Central",
        "noCleanupNeeded": "Очистка на данный момент не требуется"
      },
      "errorLoading": "Ошибка загрузки данных",
      "stats": {
        "title": "Текущая статистика",
        "totalFolders": "Всего папок",
        "totalSize": "Общий размер",
        "completeData": "Полные данные"
      },
      "formInfo": {
        "title": "Информация о форме",
        "state": "Состояние:",
        "active": "Активна:",
        "lastSubmission": "Последняя отправка:",
        "lastSync": "Последняя синхронизация:",
        "yes": "Да",
        "no": "Нет"
      },
      "recommendation": {
        "title": "Рекомендация по очистке",
        "action": "Действие:",
        "reason": "Причина:",
        "requiresApproval": "Требуется подтверждение для очистки"
      },
      "buttons": {
        "refresh": "Обновить статистику",
        "dryRun": "Тестовый запуск",
        "cleanupNow": "Очистить сейчас",
        "forceCleanup": "Принудительная очистка"
      },
      "results": {
        "title": "Результат последней очистки",
        "strategy": "Стратегия:",
        "kept": "Оставлено: {count} папок",
        "deleted": "Удалено: {count} папок",
        "archived": "Архивировано: {count} папок",
        "skipped": "Пропущено: {count} папок"
      },
      "folders": {
        "title": "Последние папки ({count})",
        "columns": {
          "name": "Название папки",
          "created": "Создана",
          "size": "Размер (МБ)",
          "files": "Файлы"
        }
      }
    },
    "messages": {
      "globalCleanupSuccess": "Глобальная очистка успешно завершена",
      "globalCleanupFailed": "Ошибка глобальной очистки",
      "errorLoadingProjects": "Ошибка загрузки проектов",
      "errorLoadingForms": "Ошибка загрузки форм",
      "noDataOrSync": "У этой формы нет данных или она еще не синхронизирована",
      "statsLoadFailed": "Не удалось загрузить статистику очистки",
      "dryRunSuccess": "Тестовый запуск завершен - файлы не были удалены",
      "dryRunFailed": "Ошибка тестового запуска",
      "cleanupNotRecommended": "Очистка не рекомендуется для этой формы",
      "cleanupSuccess": "Очистка успешно завершена",
      "cleanupFailed": "Ошибка очистки",
      "forceNotAvailable": "Принудительная очистка недоступна для этой формы",
      "forceConfirm": "Вы уверены, что хотите выполнить принудительную очистку? Это действие нельзя отменить.",
      "forceSuccess": "Принудительная очистка успешно завершена",
      "forceFailed": "Ошибка принудительной очистки"
    }
  },
  "permissionGroups": {
    "create": "Создать группу",
    "delete": "Удалить группу",
    "assignToUser": "Назначить группу пользователю",
    "removeFromUser": "Удалить группу у пользователя",
    "roleNames": {
      "manager": "Менеджер",
      "projectMember": "Участник проекта",
      "dataViewer": "Просмотр данных",
      "dataCollector": "Сбор данных",
      "dataDownloader": "Скачивание данных",
      "dataAnalyst": "Аналитик данных",
      "qcViewer": "Просмотр QC",
      "qcEditor": "Редактирование QC",
      "monitor": "Мониторинг",
      "formDesigner": "Дизайнер форм"
    },
    "userManagement": {
      "clientGroups": "Клиентские группы разрешений",
      "clientGroupsDescription": "Группы для внешних пользователей и клиентского доступа.",
      "regularGroups": "Обычные группы разрешений",
      "regularGroupsDescription": "Группы для внутренних участников проекта.",
      "errorTitle": "Не удалось загрузить группы",
      "noProjectsTitle": "Сначала выберите проект",
      "noProjectsDescription": "Выберите проект перед назначением групп разрешений.",
      "noGroupsTitle": "Нет доступных групп",
      "noGroupsAvailable": "Нет доступных групп разрешений",
      "errorLoadingGroups": "Ошибка загрузки групп разрешений",
      "selectedGroups": "Выбранные группы",
      "selectedCount": "Выбрано: {count}",
      "selectedPill": "Выбрано",
      "includedPermissions": "Включённые разрешения",
      "groupDetailsTitle": "Детали группы",
      "groupDescriptionFallback": "Описание не указано.",
      "rolesCount": "Ролей: {count}",
      "viewGroupDetails": "Показать роли группы {name}"
    }
  },
  "menu": {
    "dashboard": "Панель управления",
    "my-organization": "Моя организация",
    "userManagement": "Управление пользователями",
    "organizationStats": "Статистика организации",
    "organizationSettings": "Настройки организации",
    "projects": "Проекты",
    "odkServers": "ODK Сервера",
    "odkSync": "Синхронизация ODK",
    "payments": "Платежи",
    "faq": "Справка",
    "help": "Справка",
    "preferences": "Настройки аккаунта",
    "settings": "Настройки приложения",
    "billing": "Биллинг"
  },
  "organization": {
    "settingsSubtitle": "Управление профилем организации, подпиской AI, картами и подключённой инфраструктурой.",
    "profile": {
      "sectionTitle": "Профиль организации",
      "name": "Название",
      "description": "Описание",
      "edit": "Изменить",
      "editTitle": "Редактирование организации",
      "noDescription": "Описание не указано",
      "created": "Создана",
      "updated": "Обновлена",
      "loadError": "Не удалось загрузить профиль организации"
    },
    "infrastructure": {
      "sectionTitle": "Подключённая инфраструктура",
      "subtitle": "Сводка по серверам, проектам, пользователям и активным формам.",
      "servers": "ODK-серверы",
      "projects": "Проекты",
      "users": "Пользователи",
      "activeForms": "Активные формы",
      "defaultServer": "Сервер ODK по умолчанию",
      "noDefaultServer": "Сервер по умолчанию не выбран",
      "manageServers": "Управление ODK-серверами",
      "viewSync": "Открыть Sync Workbench",
      "loadError": "Не удалось загрузить сводку по инфраструктуре"
    },
    "quickLinks": {
      "sectionTitle": "Связанные разделы",
      "userManagement": "Управление пользователями",
      "statistics": "Статистика организации",
      "projects": "Проекты",
      "reportTemplates": "Шаблоны отчётов",
      "odkServers": "ODK-серверы",
      "syncWorkbench": "Синхронизация"
    }
  },
  "preferences": {
    "title": "Настройки",
    "subtitle": "Просмотр профиля аккаунта, доступа к организации, групп прав и ролей по проектам.",
    "accessOverview": "Обзор доступа",
    "organizationOwner": "Владелец организации",
    "organizationOwnerDescription": "У вас полный доступ ко всем ресурсам и проектам организации.",
    "permissionGroups": "Группы прав",
    "permissionGroupsDescription": "Группы по проектам и их роли",
    "perProject": "По проекту",
    "noProjectGroups": "Нет групп, привязанных к проекту.",
    "projectsAccess": "Доступ к проектам",
    "projectsAccessDescription": "Проекты, которые вы можете открыть, и ваши роли",
    "ownerNoProjects": "Как владелец организации вы имеете полный доступ. Проекты появятся после создания или импорта.",
    "noProjectAccess": "Доступ к проектам пока не предоставлен.",
    "projectIdLabel": "ID: {id}",
    "projectLabelFallback": "Проект #{id}",
    "memberSince": "Участник с:",
    "userFallback": "Пользователь",
    "invalidDate": "Недопустимая дата",
    "name": "Имя",
    "email": "Эл. почта",
    "password": "Пароль",
    "resetPassword": "Сбросить пароль",
    "emailSubscriptions": "Подписки по e-mail",
    "emailSubscriptionsVisit": "Чтобы управлять рассылкой, перейдите в",
    "notificationSettingsLink": "Настройки уведомлений",
    "cancelAccount": "Удалить учётную запись",
    "cancelAccountDescription": "Безвозвратно удалить организацию, пользователей и все связанные данные.",
    "cancelAccountAction": "Удалить учётную запись",
    "editName": "Изменить имя",
    "editNameSubtitle": "Имя, отображаемое в приложении.",
    "nameRequired": "Укажите имя",
    "nameMinLength": "Имя должно содержать не менее 2 символов",
    "nameUpdateFailed": "Не удалось обновить имя. Попробуйте снова.",
    "nameChangedSuccess": "Имя успешно изменено",
    "resetPasswordTitle": "Сброс пароля",
    "resetPasswordSubtitle": "Введите текущий пароль и задайте новый.",
    "passwordRequirementsTitle": "Требования к паролю",
    "currentPassword": "Текущий пароль",
    "newPassword": "Новый пароль",
    "repeatNewPassword": "Повторите новый пароль",
    "passwordMinLength": "Не менее 8 символов",
    "passwordUniqueChars": "Не менее 6 уникальных символов",
    "updatePassword": "Обновить пароль",
    "passwordChangedSuccess": "Пароль успешно изменён",
    "passwordUpdateFailed": "Не удалось обновить пароль. Попробуйте снова.",
    "currentPasswordRequired": "Обязательно укажите текущий пароль",
    "newPasswordRequired": "Обязательно укажите новый пароль",
    "repeatPasswordRequired": "Обязательно повторите новый пароль",
    "passwordMatchUnique": "Новый пароль не должен совпадать с текущим",
    "confirmPasswordMismatch": "Подтверждение не совпадает с новым паролем",
    "dangerZoneTitle": "Опасная зона",
    "dangerZoneSubtitle": "Необратимые действия, затрагивающие всю организацию.",
    "cancelAccountModalTitle": "Удаление учётной записи",
    "cancelAccountModalSubtitle": "Подтвердите личность и согласие на безвозвратное удаление учётной записи.",
    "cancelAccountConsequenceOrg": "Организация и все проекты будут удалены",
    "cancelAccountConsequenceUsers": "Все участники организации потеряют доступ",
    "cancelAccountConsequenceOdk": "Связанные данные ODK могут быть безвозвратно удалены",
    "cancelAccountConsequenceIrreversible": "Это действие нельзя отменить",
    "cancelAccountConfirmEmailLabel": "Введите ваш email для подтверждения",
    "cancelAccountConfirmEmailRequired": "Подтверждение email обязательно",
    "cancelAccountConfirmEmailMismatch": "Email не совпадает с вашей учётной записью",
    "cancelAccountAcknowledge": "Я понимаю, что это безвозвратно удалит мою организацию и все связанные данные",
    "cancelAccountAcknowledgeRequired": "Необходимо подтвердить понимание последствий",
    "cancelAccountDeleteButton": "Удалить учётную запись безвозвратно",
    "cancelAccountUnavailableTitle": "Удаление учётной записи пока недоступно",
    "cancelAccountUnavailableMessage": "Личность подтверждена. Функция удаления готовится — обратитесь к администратору или в поддержку для закрытия учётной записи.",
    "cancelAccountWrongPassword": "Неверный пароль. Попробуйте снова.",
    "dangerZoneCancelAccount": "Опасная зона: Удаление учётной записи",
    "cancelAccountWarning": "Это безвозвратно удалит учётную запись и все связанные данные, включая организацию, пользователей и данные ODK.",
    "groupFallback": "Группа"
  },
  "faq": {
    "title": "Справка",
    "subtitle": "Краткие инструкции и ответы на типичные задачи в UDACAPI."
  },
  "help": {
    "title": "Справка",
    "subtitle": "Краткие инструкции и ответы на типичные задачи в UDACAPI.",
    "searchPlaceholder": "Поиск по инструкциям и вопросам…",
    "learnMore": "Подробнее",
    "openGuide": "Открыть",
    "openGuideFormScope": "Откройте дашборд — затем выберите проект и форму",
    "whenToUse": "Когда использовать",
    "steps": "Шаги",
    "comingSoon": "Скоро появятся инструкции по анализу, мониторингу и настройкам организации.",
    "noResults": "Нет инструкций по вашему запросу.",
    "featureGuides": {
      "odkServers": {
        "title": "Серверы ODK",
        "summary": "Подключите ODK Central (или совместимый сервер), чтобы UDACAPI мог синхронизировать проекты и submissions.",
        "whenToUse": "Первичная настройка; перед синхронизацией или импортом.",
        "steps": [
          "Откройте Серверы ODK в боковом меню.",
          "Добавьте URL сервера и учётные данные.",
          "Запустите Проверку подключения.",
          "Исправьте URL, учётные данные или сеть перед синхронизацией."
        ]
      },
      "sync": {
        "title": "Sync Workbench",
        "summary": "Загружает новые submissions и обновляет структуру форм из ODK.",
        "whenToUse": "После подключения сервера; когда ожидаете новые данные.",
        "steps": [
          "Откройте Sync Workbench.",
          "Выберите сервер, проект и форму.",
          "Проверьте курсор и статус последней синхронизации.",
          "Запустите sync и дождитесь завершения.",
          "Откройте форму — Обзор, Экспорт или QC."
        ]
      },
      "import": {
        "title": "Импорт проектов и форм",
        "summary": "Импортирует существующие ODK-проекты и формы в организацию.",
        "whenToUse": "Миграция с ODK или подключение нового сервера.",
        "steps": [
          "Убедитесь, что сервер ODK подключён и протестирован.",
          "В Проектах запустите Импорт (только серверы организации).",
          "Выберите проект и импортируйте формы.",
          "Откройте форму и проверьте Обзор и Настройки."
        ]
      },
      "xlsformAssist": {
        "title": "XLSForm Assist",
        "summary": "AI-верстка для черновика, предпросмотра и публикации изменений XLSForm.",
        "whenToUse": "Новые опросы или крупные изменения схемы.",
        "steps": [
          "Откройте проект и запустите XLSForm Assist.",
          "Опишите опрос или загрузите файл с вопросами.",
          "Проверьте предпросмотр ODK Web Forms.",
          "Подтвердите публикацию и дождитесь завершения задачи."
        ]
      },
      "formOverview": {
        "title": "Обзор формы",
        "summary": "Сводка по сбору, timeline, карте и AI Q&A за выбранный период.",
        "whenToUse": "Ежедневный мониторинг; быстрые вопросы по данным формы.",
        "steps": [
          "Откройте форму → Обзор.",
          "Выберите период (7 / 30 / все) — общий для AI-отчётов и timeline.",
          "Просмотрите timeline и карту.",
          "Используйте AI-чат или сгенерируйте summary за тот же период."
        ]
      },
      "autoReports": {
        "title": "Автоотчёты",
        "summary": "Плановые и ручные AI-отчёты по форме с отправкой по email.",
        "whenToUse": "Регулярные обновления для stakeholders (еженедельно/ежемесячно).",
        "steps": [
          "Организация → Шаблоны отчётов — создайте или выберите шаблон.",
          "Форма → Автоотчёты — настройте расписание и получателей.",
          "Generate — ручной preview с выбором периода.",
          "Send — доставка после preview."
        ]
      },
      "qc": {
        "title": "Контроль качества (QC)",
        "summary": "Правила проверки submissions; AI может предложить стартовый набор.",
        "whenToUse": "После первых submissions; перед экспортом и анализом.",
        "steps": [
          "Откройте форму → QC.",
          "Создайте правило или используйте AI suggest.",
          "Запустите валидацию.",
          "Просмотрите помеченные submissions."
        ]
      },
      "export": {
        "title": "Экспорт данных",
        "summary": "Экспорт submissions в CSV, Excel и др.; большие формы — фоновые задачи.",
        "whenToUse": "Передача в Excel, SPSS, Stata или внешние пайплайны.",
        "steps": [
          "Откройте форму → Экспорт данных.",
          "Выберите формат и параметры.",
          "Запустите экспорт и дождитесь задачи.",
          "Скачайте файл из списка задач."
        ]
      }
    },
    "faq": {
      "title": "Часто задаваемые вопросы",
      "items": {
        "sync-no-new-data": {
          "question": "Почему sync не подтягивает новые submissions?",
          "answer": "Проверьте доступность сервера ODK, что курсор sync не застрял на старой позиции, выбрана правильная форма и у вас есть доступ к проекту. Запустите Проверку подключения на сервере, затем повторите sync в Sync Workbench."
        },
        "sync-cursor": {
          "question": "Что такое курсор sync?",
          "answer": "Курсор — указатель инкрементальной синхронизации, где UDACAPI остановил чтение submissions. Сброс или смещение курсора может пропустить или повторно загрузить данные; проверьте статус в Sync Workbench перед полным re-sync."
        },
        "import-server-type": {
          "question": "Почему нельзя импортировать с этого сервера?",
          "answer": "Импорт проектов разрешён только с серверов, принадлежащих организации. Shared и Global серверы не подходят — подключите org-сервер или обратитесь к администратору."
        },
        "import-how": {
          "question": "Как импортировать существующий ODK-проект?",
          "answer": "Подключите и протестируйте сервер, затем Проекты → Импорт, выберите проект и импортируйте формы. Подробные шаги — в инструкции «Импорт проектов и форм» выше."
        },
        "xlsform-where": {
          "question": "Где находится XLSForm Assist?",
          "answer": "Откройте проект из Проектов, затем запустите XLSForm Assist из раздела форм проекта."
        },
        "ai-scope": {
          "question": "На что может отвечать AI по форме?",
          "answer": "На вопросы о схеме формы, submissions, аналитике, правилах QC и статусе sync — на основе актуальных данных формы. Не заменяет подписание QC или юридическую проверку персональных данных."
        },
        "ai-quota": {
          "question": "Почему появляется quota exceeded?",
          "answer": "Организация исчерпала лимит использования агента. Дождитесь сброса окна или обратитесь к владельцу организации / администратору."
        },
        "auto-generate-vs-schedule": {
          "question": "Чем Generate отличается от планового отчёта?",
          "answer": "Generate запускается вручную для выбранного на форме периода. Плановый запуск следует cron шаблона и использует окно данных по расписанию — не обязательно то же, что селектор периода на Обзоре."
        },
        "auto-templates": {
          "question": "Где управлять шаблонами отчётов?",
          "answer": "На уровне организации: Моя организация → Шаблоны отчётов. Шаблоны централизованы; на вкладке Автоотчёты формы видны шаблоны, покрывающие эту форму."
        },
        "qc-first-rule": {
          "question": "Как создать первое правило QC?",
          "answer": "Форма → QC → Создать правило, или AI suggest для черновика стартового набора, затем запустите валидацию."
        },
        "export-slow": {
          "question": "Экспорт долго выполняется — это нормально?",
          "answer": "Да для больших форм. Экспорт идёт фоновыми задачами. Оставьте страницу открытой или вернитесь в Экспорт данных для скачивания после завершения."
        },
        "export-where": {
          "question": "Где файл экспорта?",
          "answer": "На вкладке Экспорт данных формы — в списке задач/истории с кнопкой скачивания при статусе complete."
        },
        "permissions-missing": {
          "question": "Не вижу проект или вкладку",
          "answer": "Ваша группа прав может не включать этот проект или функцию. Попросите владельца организации проверить группы прав и доступ к проектам."
        }
      }
    },
    "support": {
      "title": "Нужна дополнительная помощь?",
      "body": "Свяжитесь с поддержкой UDACAPI, если эти инструкции не решили проблему.",
      "contactLabel": "Написать в поддержку"
    }
  },
  "settings": {
    "title": "Настройки",
    "subtitle": "Внешний вид и язык интерфейса в этом браузере.",
    "appearanceSection": "Внешний вид",
    "appearanceSectionSubtitle": "Светлая или тёмная тема интерфейса.",
    "themeLabel": "Тема",
    "languageSection": "Язык",
    "languageSectionSubtitle": "Язык интерфейса. Применяется сразу и сохраняется в этом браузере."
  },
  "projects": {
    "pageTitle": "Проекты",
    "subtitle": "Управление проектами, переключение между карточками и таблицей, запуск импорта и создания.",
    "refresh": "Обновить",
    "createProject": "Создать проект",
    "importRestrictions": {
      "message": "Импорт проектов разрешен только с серверов, принадлежащих организации. Shared и Global серверы не могут быть использованы для импорта проектов."
    },
    "viewMode": {
      "cards": "Карточки",
      "table": "Таблица"
    },
    "sections": {
      "forms": {
        "title": "Формы проекта"
      },
      "users": {
        "title": "Пользователи проекта"
      },
      "formAccess": {
        "title": "Доступ к формам",
        "description": "Выберите, какие App Users могут скачивать каждую форму в ODK Collect.",
        "save": "Сохранить",
        "discard": "Отменить",
        "saving": "Сохранение…",
        "saved": "Доступ к формам сохранён",
        "saveError": "Не удалось сохранить все изменения",
        "loadError": "Не удалось загрузить доступ к формам",
        "emptyForms": "В проекте нет опубликованных форм",
        "emptyAppUsers": "Пока нет App Users. Сначала создайте QR-код.",
        "openQr": "Открыть QR workbench",
        "openForms": "Открыть формы",
        "dirtyHint": "Есть несохранённые изменения"
      },
      "info": {
        "title": "Информация о проекте",
        "basicInfo": "Основная информация",
        "accessInfo": "Доступ",
        "statistics": "Статистика проекта",
        "fields": {
          "projectId": "ID проекта",
          "name": "Название",
          "description": "Описание",
          "status": "Статус",
          "orgId": "ID организации",
          "odkProjectId": "ID проекта ODK",
          "createdAt": "Дата создания",
          "updatedAt": "Последнее обновление",
          "yourRole": "Ваша роль",
          "canManageForms": "Управление формами",
          "canViewUsers": "Просмотр пользователей",
          "isManager": "Менеджер",
          "isOwner": "Владелец",
          "totalUsers": "Пользователи проекта"
        },
        "status": {
          "active": "Активен",
          "archived": "Архивирован"
        },
        "noDescription": "Описание не указано",
        "loading": "Загрузка информации о проекте...",
        "loadError": "Не удалось загрузить информацию о проекте",
        "statsLoadError": "Не удалось загрузить статистику проекта",
        "invalidDate": "Некорректная дата",
        "notAvailable": "Н/Д"
      }
    },
    "users": {
      "dialog": {
        "addTitle": "Добавить пользователя в проект",
        "editTitle": "Редактировать доступ к проекту",
        "addSubtitle": "Сначала выберите пользователя, затем назначьте ему группы разрешений для этого проекта.",
        "editSubtitle": "Проверьте выбранного пользователя и обновите группы разрешений для этого проекта.",
        "stepOne": "Шаг 1",
        "stepTwo": "Шаг 2",
        "stepReady": "Готово",
        "stepRequired": "Обязательно",
        "stepLocked": "Недоступно",
        "selectUserTitle": "Выберите пользователя",
        "selectedUser": "Выбранный пользователь",
        "selectUserHint": "Выберите, кому нужно выдать доступ к этому проекту.",
        "selectedUserHint": "Этот пользователь уже добавлен в проект. Ниже можно обновить его группы разрешений.",
        "selectUserPlaceholder": "Выберите пользователя",
        "selectUserHelper": "Владельцы и суперпользователи не показываются в этом списке.",
        "permissionGroupsTitle": "Группы разрешений",
        "permissionGroupsHint": "Выберите одну или несколько групп разрешений для выбранного пользователя.",
        "permissionGroupsLockedTitle": "Сначала выберите пользователя",
        "permissionGroupsLockedHint": "Группы разрешений станут доступны после выбора пользователя.",
        "addToProject": "Добавить в проект",
        "clientUser": "Клиент",
        "internalUser": "Внутренний пользователь"
      },
      "dialogs": {
        "removeUser": {
          "title": "Удалить пользователя из проекта",
          "message": "Вы действительно хотите удалить этого пользователя из проекта?",
          "confirm": "Удалить"
        }
      },
      "list": {
        "searchPlaceholder": "Поиск пользователей",
        "filterByPermissionGroups": "Фильтр по группам разрешений",
        "accessDeniedTitle": "Нет доступа",
        "accessDeniedMessage": "У вас нет прав для просмотра пользователей этого проекта.",
        "loadErrorTitle": "Не удалось загрузить пользователей проекта",
        "emptyTitle": "В проекте пока нет пользователей",
        "emptyMessage": "Добавьте первого пользователя, чтобы начать управлять доступом к проекту.",
        "emptyFilteredTitle": "По текущим фильтрам пользователи не найдены",
        "emptyFilteredMessage": "Попробуйте изменить строку поиска или выбранные группы разрешений.",
        "noPermissionGroups": "Нет групп разрешений"
      },
      "messages": {
        "saveSuccess": "Доступ пользователя к проекту успешно обновлён.",
        "removeSuccess": "Пользователь удалён из проекта."
      },
      "errors": {
        "assignGroupsFailed": "Не удалось назначить группы разрешений. Попробуйте снова.",
        "assignRoleFailed": "Не удалось назначить роль проекта.",
        "loadUsersFailed": "Не удалось загрузить пользователей проекта.",
        "permissionGroupsLoadFailed": "Не удалось загрузить группы разрешений.",
        "projectMemberRoleFailed": "Не удалось определить роль project member.",
        "removeUserFailed": "Не удалось удалить пользователя из проекта.",
        "rolesLoadFailed": "Не удалось загрузить роли проекта.",
        "saveUserFailed": "Не удалось обновить доступ к проекту."
      }
    },
    "modal": {
      "addProject": "Добавить проект",
      "editProject": "Редактировать проект",
      "unsavedChanges": "Форма содержит несохраненные изменения. Вы уверены, что хотите закрыть её?"
    },
    "form": {
      "projectName": {
        "label": "Название проекта",
        "placeholder": "Введите название проекта",
        "required": "Название проекта обязательно"
      },
      "odkServer": {
        "label": "ODK Сервер",
        "placeholder": "Выберите ODK сервер",
        "required": "ODK Сервер обязателен",
        "noServers": "Нет доступных ODK серверов. Пожалуйста, сначала добавьте сервер."
      },
      "description": {
        "label": "Описание",
        "placeholder": "Необязательное описание проекта"
      },
      "buttons": {
        "cancel": "Отмена"
      }
    },
    "cards": {
      "noProjects": "Нет проектов",
      "status": {
        "active": "Активный",
        "archived": "Архивирован"
      }
    },
    "confirmations": {
      "odkServerRequired": "Пожалуйста, добавьте хотя бы один ODK сервер перед созданием проекта.",
      "delete": {
        "imported": {
          "title": "Удалить импортированный проект",
          "message": "Вы уверены, что хотите удалить проект \"{name}\"?\n\nЭтот проект был импортирован из ODK Central. Он будет удален только из базы данных этого приложения, но останется на сервере ODK Central.",
          "messageWithStats": "Вы уверены, что хотите удалить проект \"{name}\"?\n\nВ проекте есть {formsCount} форм и {submissionsCount} submissions.\nПроект будет архивирован/скрыт (soft-delete), данные сохранятся.\n\nЭтот проект был импортирован из ODK Central. Он будет удален только из базы данных этого приложения, но останется на сервере ODK Central."
        },
        "regular": {
          "title": "Удалить проект",
          "message": "Вы уверены, что хотите удалить проект \"{name}\"?\n\nПРЕДУПРЕЖДЕНИЕ: Это навсегда удалит проект из базы данных этого приложения и с сервера ODK Central.",
          "messageWithStats": "Вы уверены, что хотите удалить проект \"{name}\"?\n\nВ проекте есть {formsCount} форм и {submissionsCount} submissions.\nПроект будет архивирован/скрыт (soft-delete), данные сохранятся."
        },
        "confirmButton": "Удалить"
      }
    },
    "notifications": {
      "organizationNotSelected": "Организация не выбрана"
    },
    "import": {
      "title": "Импорт проектов ODK",
      "subtitle": "Загрузка доступных проектов ODK с сервера организации и импорт в текущее рабочее пространство.",
      "selectServer": "Выберите сервер ODK",
      "getProjects": "Получить проекты",
      "availableProjects": "Доступные проекты",
      "noProjectsFound": "Проекты не найдены на выбранном сервере.",
      "importProject": "Импортировать",
      "imported": "Импортирован",
      "errors": {
        "serversLoadFailed": "Не удалось загрузить серверы ODK. Пожалуйста, попробуйте позже.",
        "projectsLoadFailed": "Не удалось загрузить проекты с сервера ODK. Пожалуйста, проверьте подключение и попробуйте снова.",
        "importFailed": "Не удалось импортировать проект. Пожалуйста, попробуйте позже.",
        "importError": "Ошибка при импорте проекта: {detail}"
      }
    },
    "importForms": {
      "title": "Импорт форм ODK",
      "subtitle": "Выберите формы из проекта ODK Central, чтобы добавить их сюда.",
      "subtitleWithProject": "Выберите формы из проекта Central {odkProjectId}, чтобы добавить их в «{name}».",
      "loadingForms": "Загрузка форм с сервера ODK...",
      "availableForms": "Доступные формы",
      "searchForms": "Поиск форм...",
      "selectAll": "Выбрать все",
      "deselectAll": "Отменить выбор",
      "importSelected": "Импортировать выбранные",
      "noFormsFound": "Формы не найдены для данного проекта на сервере ODK.",
      "errors": {
        "projectNotLinked": "Проект не связан с сервером ODK",
        "formsLoadFailed": "Не удалось загрузить формы с сервера ODK. Пожалуйста, попробуйте позже.",
        "formsLoadError": "Ошибка при загрузке форм: {detail}",
        "importFailed": "Не удалось импортировать формы. Пожалуйста, попробуйте позже.",
        "importError": "Ошибка импорта: {detail}"
      },
      "status": {
        "imported": "Импортирована",
        "available": "Доступна"
      },
      "progress": {
        "started": "Импорт запущен",
        "completedSummary": "Формы готовы в этом проекте.",
        "failedSummary": "Некоторые формы не удалось импортировать. Подробности ниже.",
        "viewProject": "Открыть проект",
        "forms": "{done} / {total} форм",
        "submissions": "{count} записей обработано",
        "submissionsProgress": "{fetched} / {total} записей синхронизировано",
        "stages": {
          "queued": "Ожидание запуска",
          "pending": "Ожидание запуска",
          "importingForms": "Импорт форм",
          "syncingData": "Синхронизация данных"
        },
        "messages": {
          "queued": "Задача добавлена в очередь, ожидание запуска...",
          "importingForms": "Импорт метаданных форм..."
        }
      }
    },
    "detail": {
      "loading": "Загрузка проекта...",
      "returnToProjects": "Вернуться к проектам",
      "forms": {
        "title": "Формы проекта",
        "noForms": "В проекте отсутствуют формы.",
        "contactAdmin": "Обратитесь к администратору для добавления форм.",
        "actions": {
          "publish": "Опубликовать",
          "abandon": "Отказаться",
          "attachments": "Вложения",
          "qrCode": "QR-код для тестирования",
          "previewEnketo": "Просмотр в Enketo",
          "downloadTestData": "Скачать тестовые данные",
          "formSettings": "Настройки формы",
          "viewDetails": "Просмотр/Детали",
          "changeState": "Изменить статус",
          "delete": "Удалить/Отказаться"
        },
        "modals": {
          "qrCode": {
            "title": "QR-код для тестирования",
            "description": "Отсканируйте QR-код, чтобы протестировать форму"
          },
          "formSettings": {
            "title": "Настройки формы",
            "basicSettings": "Основные настройки (Placeholder)",
            "accessSettings": "Настройки доступа (Placeholder)",
            "placeholder": "Это демонстрационный интерфейс. Функциональность в разработке."
          }
        },
        "messages": {
          "tryAgain": "Попробовать снова",
          "publishing": "Публикация формы {name}...",
          "published": "Форма {name} успешно опубликована",
          "previewing": "Предпросмотр {name} в Enketo (dev placeholder)",
          "downloading": "Скачивание тестовых данных для {name} (dev placeholder)",
          "saving": "Сохранение настроек для {name} (dev placeholder)",
          "missingData": "Не хватает данных для импорта форм",
          "missingXlsformData": "Не хватает данных для загрузки XLSForm",
          "noAttachments": "У формы нет вложений"
        }
      }
    },
    "qc": {
      "rules": {
        "ruleTypes": {
          "required": "Обязательное поле",
          "constraint": "Ограничение",
          "calculation": "Расчет",
          "custom": "Пользовательское"
        },
        "severity": {
          "error": "Ошибка",
          "warning": "Предупреждение",
          "info": "Информация"
        },
        "form": {
          "tabs": {
            "basic": "Основные настройки",
            "preview": "Preview"
          },
          "ruleNameLabel": "Название правила *",
          "ruleNamePlaceholder": "Введите название правила",
          "ruleTypeLabel": "Тип правила *",
          "severityLabel": "Уровень серьезности *",
          "fieldPathLabel": "Путь к полю *",
          "fieldPathPlaceholder": "respondent.age",
          "constraintExpressionLabel": "Выражение ограничения *",
          "calculationFormulaLabel": "Формула расчета *",
          "simpleEditor": "Простой редактор",
          "jsonLogicBuilder": "JSONLogic Builder",
          "applyJsonLogic": "Применить JSONLogic",
          "errorMessageLabel": "Сообщение об ошибке *",
          "errorMessagePlaceholder": "Введите сообщение об ошибке",
          "activeLabel": "Правило активно",
          "previewTitle": "Предварительный просмотр правила",
          "runPreview": "Запустить Preview",
          "previewHint": "Тестирует правило на выборке данных",
          "invalidJson": "Неверный JSON формат",
          "createExpressionFirst": "Сначала создайте выражение правила",
          "previewError": "Ошибка при выполнении preview",
          "previewResults": "Результаты preview ({count} записей):",
          "passed": "Прошли:",
          "failed": "Не прошли:",
          "successRate": "Процент успеха:",
          "validation": {
            "ruleNameRequired": "Название правила обязательно",
            "fieldPathRequired": "Путь к полю обязателен",
            "errorMessageRequired": "Сообщение об ошибке обязательно",
            "constraintExpressionRequired": "Выражение ограничения обязательно",
            "calculationFormulaRequired": "Формула расчета обязательна"
          },
          "toasts": {
            "ruleCreated": "Правило создано",
            "ruleUpdated": "Правило обновлено",
            "saveError": "Ошибка сохранения правила"
          }
        }
      }
    }
  },
  "odkServers": {
    "title": "ODK Серверы",
    "subtitle": "Управление ODK-эндпоинтами организации, сервером по умолчанию, видимостью и состоянием подключения.",
    "contextHint": "Подключите сервер ODK перед синхронизацией или импортом форм.",
    "addServer": "Добавить сервер",
    "editServer": "Редактировать сервер",
    "deleteServer": "Удалить сервер",
    "modal": {
      "addSubtitle": "Подключите сервер ODK Central к этой организации.",
      "editSubtitle": "Измените параметры подключения к серверу."
    },
    "table": {
      "default": "По умолчанию",
      "visibility": "Видимость",
      "setAsDefault": "Установить по умолчанию",
      "setAsDefaultTooltip": "Установить как сервер по умолчанию для этой организации",
      "testConnection": "Тестировать подключение",
      "testConnectionTooltip": "Тестировать подключение к серверу ODK Central",
      "testConnectionDisabled": "Тестирование подключения доступно только для серверов, принадлежащих организации",
      "editServer": "Редактировать сервер",
      "editServerTooltip": "Редактировать детали сервера (только для серверов ORGANIZATION и при наличии разрешений)",
      "deleteServer": "Удалить сервер",
      "deleteServerTooltip": "Удалить сервер (только для серверов ORGANIZATION и при наличии разрешений)",
      "odkSession": "Сессия ODK"
    },
    "session": {
      "banner": "У одного или нескольких серверов истекает или недействительна сессия ODK Central, либо не сохранён пароль. Отредактируйте сервер и сохраните пароль, чтобы приложение могло переподключаться автоматически.",
      "ok": "Сессия в порядке",
      "expiresSoon": "Скоро истечёт",
      "expired": "Истекла",
      "unknown": "Неизвестно",
      "noStoredPassword": "Пароль не сохранён"
    },
    "form": {
      "serverName": "Название сервера",
      "serverUrl": "URL сервера",
      "serverUrlPlaceholder": "https://your-odk-central.com",
      "username": "Имя пользователя",
      "password": "Пароль",
      "passwordPlaceholderEdit": "Оставьте пустым, чтобы не изменять",
      "description": "Описание",
      "serverIsActive": "Сервер активен",
      "serverIsActiveHint": "Неактивные серверы остаются в списке, но не предлагаются при создании проектов."
    },
    "validation": {
      "serverNameRequired": "Название сервера обязательно",
      "serverUrlRequired": "URL сервера обязателен",
      "urlFormatInvalid": "URL должен начинаться с http:// или https://",
      "usernameRequired": "Имя пользователя обязательно",
      "passwordRequired": "Пароль обязателен"
    },
    "messages": {
      "selectOrganizationFirst": "Пожалуйста, сначала выберите или создайте организацию",
      "loadingServers": "Загрузка серверов...",
      "noServersFound": "ODK серверы для этой организации не найдены",
      "failedToLoadServers": "Не удалось загрузить серверы",
      "noServers": "Нет ODK серверов",
      "serverSaved": "Сервер \"{name}\" {action} успешно!",
      "serverSetAsDefault": "Сервер \"{name}\" установлен по умолчанию",
      "connectionTestSuccess": "Подключение успешно. Найдено проектов: {count}",
      "connectionTestFailed": "Тест подключения не удался"
    }
  },
  "notifications": {
    "all": "Смотреть все",
    "less": "Смотреть меньше"
  },
  "language": {
    "label": "Язык",
    "english": "Английский",
    "spanish": "Испанский",
    "french": "Французский",
    "swahili": "Суахили",
    "portuguese": "Португальский",
    "ukrainian": "Украинский",
    "russian": "Русский",
    "turkish": "Турецкий"
  },
  "auth": {
    "createAccount": "Создать аккаунт",
    "dontHaveAccount": "Нет аккаунта?",
    "email": "Email",
    "emailInvalid": "Email должен быть корректным",
    "emailRequired": "Поле Email обязательно",
    "enterEmail": "Введите ваш email",
    "enterVerificationCode": "Пожалуйста, введите код подтверждения",
    "forgotPassword": "Забыли пароль?",
    "forgotPasswordDescription": "Если вы забыли пароль, не беспокойтесь. Просто введите ваш email ниже, и мы отправим вам письмо с инструкциями по сбросу пароля. Восстановление доступа к вашему аккаунту никогда не было таким простым.",
    "fullName": "Полное имя",
    "fullNameRequired": "Поле Полное имя обязательно",
    "goBack": "Назад",
    "haveAccount": "Уже есть аккаунт?",
    "login": "Вход",
    "password": "Пароль",
    "passwordMustContainLetter": "Пароль должен содержать хотя бы одну букву",
    "passwordMustContainNumber": "Пароль должен содержать хотя бы одну цифру",
    "passwordMustContainSpecial": "Пароль должен содержать хотя бы один специальный символ",
    "passwordMustBe8Chars": "Пароль должен содержать минимум 8 символов",
    "passwordRequired": "Поле Пароль обязательно",
    "passwordRequirements": "Пароль должен содержать 8+ символов: буквы, цифры и специальные символы.",
    "passwordsDontMatch": "Пароли не совпадают",
    "registrationFailed": "Регистрация не удалась. Попробуйте еще раз.",
    "registrationSuccess": "Вы успешно зарегистрировались! Пожалуйста, проверьте ваш email для получения инструкций по активации.",
    "repeatPassword": "Повторите пароль",
    "repeatPasswordRequired": "Поле Повторите пароль обязательно",
    "resetInstructionsSent": "Инструкции по сбросу пароля отправлены на ваш email.",
    "resetInstructionsFailed": "Не удалось отправить email для сброса пароля. Попробуйте еще раз.",
    "resetPassword": "Сбросить пароль",
    "sendResetInstructions": "Отправить инструкции по сбросу",
    "signUp": "Зарегистрироваться",
    "twoFactorAuthentication": "Двухфакторная аутентификация",
    "verificationCode": "Код подтверждения",
    "verificationCodeRequired": "Код подтверждения обязателен",
    "verifyCode": "Подтвердить код"
  },
  "dashboard": {
    "subtitle": "Просмотр активных форм по проектам организации с переключением между карточками и таблицей.",
    "activeFormsTitle": "Активные формы",
    "activeFormsSubtitle": "Формы в состояниях open и closing из всех проектов организации.",
    "noActiveForms": "Нет активных форм"
  },
  "qr": {
    "title": "QR-код (настройки ODK Collect)",
    "titleShort": "QR-код",
    "qrName": "Название QR-кода",
    "projectSection": "Проект",
    "projectName": "Название проекта",
    "projectIcon": "Иконка проекта",
    "projectColor": "Цвет проекта",
    "generalSection": "Общие настройки",
    "serverUrl": "URL сервера",
    "username": "Имя пользователя",
    "password": "Пароль",
    "adminSection": "Админ-настройки",
    "admin": {
      "edit_saved": "Редактирование сохранённых",
      "send_finalized": "Отправка финализированных",
      "view_sent": "Просмотр отправленных",
      "password": "Админ-пароль",
      "advanced": "Расширенные админ-настройки",
      "getBlank": "Получение пустых форм",
      "deleteSaved": "Удаление сохранённых",
      "qrCodeScanner": "Сканер QR-кода",
      "changeServer": "Смена сервера",
      "changeAppTheme": "Смена темы приложения",
      "changeAppLanguage": "Смена языка приложения",
      "changeFontSize": "Смена размера шрифта",
      "changeNavigation": "Смена навигации",
      "maps": "Карты",
      "periodicUpdates": "Периодические обновления",
      "automaticUpdate": "Автоматическое обновление",
      "hideOldVersions": "Скрывать старые версии",
      "changeAutosend": "Смена автоотправки",
      "deleteAfterSend": "Удалять после отправки",
      "defaultToFinalized": "По умолчанию финализировано",
      "changeConstraintBehavior": "Смена поведения ограничений",
      "highResolution": "Высокое разрешение",
      "imageSize": "Размер изображения",
      "guidanceHint": "Подсказки",
      "externalAppRecording": "Запись внешним приложением",
      "instanceFormSync": "Синхронизация инстансов",
      "changeFormMetadata": "Смена метаданных формы",
      "analytics": "Аналитика",
      "movingBackwards": "Перемещение назад",
      "accessSettings": "Доступ к настройкам",
      "changeLanguage": "Смена языка",
      "jumpTo": "Переход к",
      "saveMid": "Сохранение в процессе",
      "saveAs": "Сохранить как",
      "markAsFinalized": "Пометить как финализированное"
    },
    "general": {
      "theme": "Тема",
      "language": "Язык",
      "fontSize": "Размер шрифта",
      "navigation": "Навигация",
      "constraintBehavior": "Поведение ограничений",
      "advanced": "Расширенные общие настройки",
      "formlistUrl": "URL списка форм",
      "submissionUrl": "URL отправки",
      "periodicUpdates": "Периодические обновления",
      "deleteAfterSend": "Удалять после отправки",
      "defaultCompleted": "Завершено по умолчанию",
      "externalAppRecording": "Запись внешним приложением"
    },
    "formManagement": {
      "title": "Управление формами",
      "updateMode": "Режим обновления",
      "autosend": "Автоотправка",
      "imageSize": "Размер изображения",
      "automaticUpdate": "Автоматическое обновление",
      "hideOldVersions": "Скрывать старые версии",
      "instanceSync": "Синхронизация инстансов",
      "guidanceHint": "Подсказки",
      "highResolution": "Высокое разрешение"
    },
    "maps": {
      "title": "Карты",
      "basemap": "Базовая карта",
      "googleStyle": "Стиль Google",
      "mapboxStyle": "Стиль Mapbox",
      "usgsStyle": "Стиль USGS",
      "cartoStyle": "Стиль CARTO",
      "referenceLayer": "Справочный слой (путь)"
    },
    "identity": {
      "title": "Идентификация",
      "analytics": "Аналитика",
      "userName": "Имя пользователя",
      "email": "Email",
      "phone": "Телефон"
    },
    "presets": {
      "title": "Пресеты QR",
      "save": "Сохранить пресет",
      "load": "Загрузить пресет...",
      "delete": "Удалить",
      "defaultName": "Пресет {number}"
    },
    "preview": {
      "title": "Предпросмотр JSON",
      "reset": "Сбросить",
      "import": "Импорт"
    },
    "history": {
      "title": "История QR-кодов",
      "viewAll": "Смотреть все",
      "view": "Просмотр",
      "download": "Скачать",
      "copy": "Копировать",
      "delete": "Удалить",
      "more": "... и еще {count}"
    },
    "actions": {
      "generate": "Сгенерировать QR",
      "downloadPng": "Скачать PNG",
      "copyBase64": "Копировать Base64",
      "reset": "Сбросить",
      "importJson": "Импорт JSON"
    },
    "placeholders": {
      "qrName": "Мой QR-код устройства",
      "color": "#C17A3A",
      "url": "https://central.example.org",
      "icon": "📋",
      "submissionUrl": "https://.../v1/projects/:id/submissions",
      "referenceLayer": "/storage/maps/layer.mbtiles",
      "projectName": "Полевая команда"
    },
    "options": {
      "default": "По умолчанию",
      "system": "Системный"
    },
    "workbench": {
      "contextHint": "Создайте QR для ODK Collect с токеном App User в URL сервера.",
      "serverReady": "Сервер задан",
      "serverMeta": "Central: {url}",
      "serverMissing": "Central: не привязан — проверьте ODK-сервер проекта",
      "essentialsTitle": "Настройка",
      "essentialsDesc": "Назовите QR и карточку Collect, выберите иконку и цвет, затем сгенерируйте.",
      "nameHint": "Также используется как display name App User в ODK Central.",
      "projectNameHint": "Подпись конфигурации в ODK Collect (не имя проекта в udacapi).",
      "iconHint": "Отображается на карточке проекта в Collect. По умолчанию достаточно для большинства команд.",
      "changeIcon": "Сменить иконку",
      "iconDialogTitle": "Иконка проекта Collect",
      "iconDialogSubtitle": "Выберите один символ для карточки проекта на устройстве.",
      "applyIcon": "Применить",
      "serverHint": "Берётся из связанного ODK-сервера проекта. При генерации подставляется /v1/key/{token}/projects/{id}.",
      "advancedTitle": "Расширенные опции Collect",
      "advancedHint": "Тема, синхронизация форм, карты — по желанию",
      "previewTitle": "Превью",
      "previewDesc": "После генерации отсканируйте в ODK Collect.",
      "libraryHint": "Хранится в этом браузере для этого проекта.",
      "libraryEmpty": "QR-кодов пока нет. Сгенерируйте первый.",
      "libraryCount": "{count} в библиотеке"
    },
    "formAccess": {
      "title": "Формы, доступные коллектору",
      "hint": "Выберите хотя бы одну опубликованную форму. Иначе Collect покажет пустой список.",
      "selectAll": "Выбрать все",
      "clear": "Сбросить",
      "required": "Выберите хотя бы одну форму",
      "assignFailed": "Не удалось назначить формы App User",
      "manageAll": "Управление доступом к формам",
      "formsCount": "{n} форм",
      "noPublishedForms": "В проекте пока нет опубликованных форм."
    },
    "messages": {
      "nameRequiredForPreset": "Пожалуйста, введите название пресета",
      "nameRequiredForAppUser": "Название QR-кода обязательно для создания App User",
      "projectNameRequired": "Название проекта обязательно",
      "serverRequired": "URL сервера обязателен",
      "missingOdkProject": "У проекта нет ODK Central project id. Переимпортируйте или проверьте настройки проекта.",
      "invalidSettings": "Неверные настройки",
      "generateSuccess": "QR сгенерирован, App User создан",
      "generateError": "Не удалось сгенерировать QR и создать App User",
      "presetSaved": "Пресет сохранён",
      "base64Copied": "Base64 скопирован",
      "jsonImported": "Настройки импортированы из JSON",
      "invalidJsonStructure": "Неверная структура JSON. Должны быть разделы project, general и admin.",
      "invalidJsonFormat": "Неверный формат JSON",
      "copyBase64Error": "Не удалось скопировать Base64"
    },
    "placeholder": "Сгенерируйте QR-код, чтобы увидеть его здесь",
    "note": "Код содержит zlib-сжатую Base64 JSON с general/admin/project. Авторизация App User — в server_url."
  },
  "forms": {
    "state": {
      "open": "Открыта",
      "closing": "Закрывается",
      "closed": "Закрыта",
      "draft": "Черновик"
    },
    "deleteConfirm": {
      "title": "Удаление формы",
      "subtitle": "Проверьте последствия перед окончательным удалением формы.",
      "message": "Это действие нельзя отменить.",
      "xmlFormId": "XML ID: {id}",
      "confirm": "Удалить навсегда",
      "importedWarning": "Эта форма была импортирована из ODK Central. Она будет удалена только из базы данных приложения, но останется на сервере ODK Central.",
      "regularWarning": "Это действие переместит форму в корзину ODK Central и пометит её как удалённую в локальной базе данных.",
      "consequenceDataLoss": "Все ответы и история экспорта этой формы будут удалены из приложения.",
      "irreversible": "Это действие не может быть отменено через интерфейс.",
      "success": "Форма {name} была удалена.",
      "successImported": "Форма {name} была удалена только из базы данных приложения.",
      "error": "Ошибка удаления формы: {error}"
    },
    "uploadXlsform": {
      "title": "Загрузка XLSForm",
      "subtitle": "Загрузите файл .xlsx или .xls (до 50 МБ).",
      "selectFile": "Файл книги",
      "dropFileTitle": "Перетащите XLSForm сюда",
      "supportedFormats": ".xlsx или .xls, до 50 МБ.",
      "replaceFileHint": "Выберите другой файл, чтобы заменить текущий.",
      "chooseFile": "Выбрать файл",
      "selectedFile": "Выбранный файл:",
      "formSettings": "Идентификатор формы",
      "uploadOptions": "Параметры загрузки",
      "formId": "ID формы",
      "formIdPlaceholder": "my_form_id",
      "formIdHint": "Необязательный fallback. Реальный ID берётся из листа settings.",
      "formIdWarning": {
        "title": "Важно!",
        "message": "Финальный ID формы будет взят из листа 'settings' XLSForm файла. Введенный здесь ID используется только как резервный вариант."
      },
      "updateExisting": "Обновить существующую форму",
      "updateExistingHint": "Если форма с таким ID уже существует, она будет обновлена",
      "ignoreWarnings": "Игнорировать предупреждения",
      "ignoreWarningsHint": "Пропустить предупреждения валидации и продолжить загрузку",
      "publishImmediately": "Опубликовать форму сразу",
      "publishImmediatelyHint": "Автоматически опубликовать форму после загрузки",
      "uploadButton": "Загрузить XLSForm",
      "uploading": "Загрузка...",
      "noFileSelected": "Пожалуйста, выберите файл для загрузки",
      "noFormId": "Пожалуйста, укажите ID формы",
      "uploadingMessage": "Загрузка XLSForm \"{formId}\"...",
      "successMessage": "XLSForm \"{formId}\" успешно загружен!",
      "errorMessage": "Ошибка загрузки: {error}",
      "errorFallback": "Не удалось загрузить файл. Попробуйте снова.",
      "listUpdated": "XLSForm успешно загружен! Список форм обновлен."
    },
    "formDetail": {
      "loading": "Загрузка формы...",
      "formLabel": "Форма",
      "returnToProjects": "Вернуться к списку проектов",
      "sectionShell": {
        "unknownForm": "Неизвестная форма",
        "loading": "Загрузка...",
        "retry": "Повторить",
        "comingSoonTitle": "Скоро",
        "comingSoonDescription": "Эта функция в разработке. Пока используйте другие инструменты формы."
      },
      "sections": {
        "dashboard": {
          "title": "Обзор формы",
          "description": "Статистика и информация о форме и собранных данных"
        },
        "autoReports": {
          "title": "Автоотчёты",
          "description": "Плановые и разовые AI-отчёты, которые покрывают эту форму",
          "contextHint": "Расписание, доставка и разовый запуск для шаблонов, покрывающих эту форму",
          "manageTemplates": "Управление шаблонами",
          "analysisWindow": "Окно анализа",
          "empty": "Нет автоотчётов для этой формы",
          "emptyHint": "Владелец может создать шаблоны по умолчанию или назначить формы в управлении шаблонами",
          "seed": "Создать шаблоны по умолчанию",
          "loadError": "Не удалось загрузить автоотчёты",
          "scope": {
            "all": "Все формы",
            "this": "Эта форма",
            "many": "{count} форм"
          },
          "delivery": {
            "email": "Email · {count} получателей",
            "inApp": "Только в приложении"
          },
          "manualOnly": "Только вручную",
          "lastRun": "Последний запуск",
          "noLastRun": "Ещё не запускался",
          "generate": "Сгенерировать",
          "generateNow": "Сгенерировать",
          "viewLatest": "Открыть последний",
          "generating": "Генерация отчёта…",
          "started": "Отчёт запущен",
          "ribbonManual": "Без расписания · {timezone}",
          "sendToRecipients": "Отправить {n} получателям",
          "sent": "Отправлено",
          "sentToast": "Отправлено {n} получателям",
          "sendFailed": "Не удалось отправить отчёт",
          "noRecipientsHint": "Добавьте получателей в управлении шаблонами, чтобы отправить отчёт по email"
        },
        "qc": {
          "title": "Контроль качества",
          "description": "Мониторинг и валидация качества данных с помощью правил QC",
          "workbench": {
            "contextHint": "Настройте правила, проверяйте submissions и разбирайте найденные проблемы для этой формы.",
            "rulesCount": "{count} правил",
            "activeCount": "{count} активных",
            "validationsCount": "{count} проверок",
            "summaryTitle": "Обзор правил",
            "selectedCount": "Выбрано: {count}",
            "createRuleHint": "Создайте новое правило валидации для этой формы",
            "editRuleHint": "Измените настройки и выражение правила",
            "backToRules": "К списку правил",
            "pipeline": {
              "ariaLabel": "Процесс QC-валидации",
              "define": "Настроить правила",
              "defineHint": "Настроено правил: {count}",
              "defineEmpty": "Правил пока нет — создайте первую проверку",
              "validate": "Проверить данные",
              "validateHint": "Проверено submissions: {count}",
              "validateEmpty": "Запустите проверку входящих submissions",
              "review": "Разобрать проблемы",
              "reviewHint": "Открытых проблем: {count}",
              "reviewClear": "Нет нерешённых проблем"
            }
          }
        },
        "dataExport": {
          "title": "Экспорт данных",
          "description": "Экспорт данных формы в различных форматах"
        },
        "odkExport": {
          "title": "Экспорт данных",
          "description": "Экспорт данных формы в различных форматах для анализа",
          "unknownForm": "Неизвестная форма",
          "exportsCount": "{count} экспортов",
          "loadingOptions": "Загрузка параметров экспорта...",
          "retry": "Повторить",
          "infoSubtitleDetailed": "Выберите форматы экспорта и настройте параметры для загрузки данных вашей формы.",
          "formatsAvailable": "Доступно форматов: {count}",
          "formatsTitle": "Форматы экспорта",
          "selectFormats": "Выберите один или несколько форматов для экспорта",
          "statisticalFormatsTitle": "Статистические форматы",
          "geoFormatsTitle": "Географические форматы",
          "noGeoData": "В этой форме не найдено географических данных",
          "configTitle": "Конфигурация экспорта",
          "configSubtitle": "Настройте параметры экспорта и фильтры",
          "dataOptions": "Параметры данных",
          "includeRepeats": "Включить повторяющиеся группы",
          "includeLabels": "Включить метки полей",
          "includeMetadata": "Включить метаданные",
          "labelLanguage": "Язык меток",
          "selectLanguage": "Выберите язык",
          "loadingLanguages": "Загрузка языков...",
          "generatingLabels": "Генерация меток...",
          "noLabelsAvailable": "Метки недоступны. Нажмите обновить, чтобы сгенерировать метки.",
          "filters": "Фильтры",
          "dateRange": "Диапазон дат",
          "startDate": "Дата начала",
          "endDate": "Дата окончания",
          "dataFilter": "Фильтр данных",
          "dataFilterPlaceholder": "например, age > 18",
          "readyToExport": "Готов к экспорту",
          "readyToExportSubtitle": "Нажмите кнопку, чтобы начать процесс экспорта",
          "labelsRequiredNotice": "Метки обязательны, но недоступны. Пожалуйста, сначала сгенерируйте метки.",
          "activeExports": "Активные экспорты",
          "exportButton": "Экспортировать данные",
          "historyTitle": "История экспорта",
          "historySubtitle": "Просмотрите предыдущие экспорты и загрузите их",
          "refresh": "Обновить",
          "loadingHistory": "Загрузка истории...",
          "noHistory": "Экспортов пока нет",
          "noHistoryDesc": "Начните с экспорта данных в удобном для вас формате.",
          "workbench": {
            "contextHint": "Выберите форматы и параметры, затем запустите экспорт.",
            "geoAvailable": "Есть геоданные",
            "geoUnavailable": "Нет геоданных",
            "optionsTitle": "Параметры",
            "refreshLabels": "Обновить метки",
            "labelsGenerated": "Метки сгенерированы ({count} языков)",
            "exportButtonOne": "Экспортировать 1 формат",
            "exportButtonMany": "Экспортировать {count} форматов",
            "selectFormatHint": "Выберите хотя бы один формат для экспорта.",
            "readySummaryOne": "Готов к экспорту: 1 формат.",
            "readySummaryMany": "Готово к экспорту: {count} форматов.",
            "jobsTitle": "Задачи",
            "jobsSubtitle": "Отслеживайте активные экспорты и скачивайте предыдущие файлы.",
            "noActiveJobs": "Нет активных экспортов.",
            "noHistoryAction": "Выберите формат выше и запустите экспорт.",
            "pipeline": {
              "sync": "Синхронизация",
              "convert": "Конвертация",
              "ready": "Готово"
            }
          },
          "date": "Дата",
          "format": "Формат",
          "records": "Записи",
          "size": "Размер",
          "user": "Пользователь",
          "actions": "Действия",
          "download": "Скачать",
          "viewError": "Просмотр ошибки",
          "errorDetails": "Детали ошибки",
          "errorSubtitle": "Информация об ошибке экспорта",
          "close": "Закрыть",
          "deleteTitle": "Удалить экспорт",
          "deleteSubtitle": "Это действие невозможно отменить",
          "deleteConfirm": "Вы уверены, что хотите удалить экспорт от {date}? Это действие невозможно отменить.",
          "cancel": "Отмена",
          "delete": "Удалить",
          "formatDescriptions": {
            "stata": "Stata",
            "spss": "SPSS",
            "excel": "Excel",
            "csv": "CSV",
            "geojson": "GeoJSON",
            "shapefile": "ESRI Shapefile",
            "kml": "KML",
            "odata": "OData"
          },
          "dateFilters": {
            "all": "Все данные",
            "last30": "Последние 30 дней",
            "last90": "Последние 90 дней",
            "thisyear": "Этот год",
            "lastyear": "Прошлый год",
            "custom": "Произвольный период"
          },
          "status": {
            "odataSyncError": "Ошибка проверки синхронизации OData: {error}",
            "localDataMissing": "Локальные данные отсутствуют, загрузка OData...",
            "odataStatusError": "Ошибка статуса OData",
            "downloadingOdata": "Загрузка OData...",
            "downloadSuccessCount": "Загружено {count} записей",
            "downloadError": "Ошибка загрузки OData: {error}",
            "geoRequired": "{format} требует наличия географических данных"
          },
          "notifications": {
            "selectFormat": "Пожалуйста, выберите хотя бы один формат",
            "startingDownload": "Начало загрузки...",
            "downloadSuccess": "Файл успешно загружен",
            "downloadError": "Ошибка загрузки: {error}",
            "taskIdMissing": "Невозможно загрузить: отсутствует ID задачи",
            "exportDeleted": "Экспорт успешно удален",
            "exportCompleted": "Экспорт {format} завершен",
            "exportFailed": "Экспорт {format} не удался",
            "trackingError": "Ошибка отслеживания: {error}",
            "noErrorDetails": "Детали ошибки отсутствуют",
            "currentUser": "Текущий пользователь"
          }
        },
        "dataAnalysis": {
          "title": "Анализ данных",
          "description": "Создавайте сводные таблицы для анализа и сохраняйте представления в мониторинг",
          "recordsLoaded": "Загружено записей: {count}",
          "variablesSelected": "Выбрано переменных: {count}",
          "tablesAvailable": "Доступно таблиц: {count}",
          "workbench": {
            "contextHint": "Выберите переменные, постройте сводную таблицу и сохраните представление в мониторинг",
            "loadingData": "Загрузка данных...",
            "pipeline": {
              "ariaLabel": "Этапы анализа",
              "source": "Источник",
              "sourceHint": "{table}",
              "sourceEmpty": "Выберите таблицу данных",
              "variables": "Переменные",
              "variablesHint": "Выбрано: {count}",
              "variablesEmpty": "Выберите поля для анализа",
              "pivot": "Сводная таблица",
              "pivotHint": "Загружено записей: {count}",
              "pivotEmpty": "Загрузите данные для анализа",
              "pivotLoading": "Загрузка записей...",
              "save": "Сохранение",
              "saveHint": "Можно сохранить в мониторинг",
              "saveEmpty": "Сначала настройте сводную таблицу"
            },
            "source": {
              "title": "Источник данных",
              "subtitle": "Выберите таблицу отправок и способ отображения значений",
              "labelsMissing": "Для этой формы не сгенерированы метки",
              "labelsMissingHint": "Сгенерируйте метки из XLSForm, чтобы показывать названия переменных и значений.",
              "generateLabels": "Сгенерировать метки",
              "table": "Таблица данных",
              "tablePlaceholder": "Выберите таблицу данных",
              "displayOptions": "Параметры отображения",
              "showLabels": "Показывать метки",
              "language": "Язык",
              "includeMetadata": "Включить метаданные"
            },
            "variables": {
              "title": "Переменные",
              "selectedCount": "Выбрано: {count}",
              "selectTableFirst": "Сначала выберите таблицу данных.",
              "selectAll": "Выбрать все",
              "clearAll": "Очистить",
              "searchPlaceholder": "Поиск переменных...",
              "empty": "Нет переменных по вашему запросу",
              "moreCount": "ещё {count}",
              "loading": "Загрузка...",
              "loadCta": "Загрузить {count} переменных"
            },
            "pivot": {
              "title": "Сводная таблица",
              "subtitle": "Перетащите поля в строки, столбцы или значения",
              "hint": "Перетащите переменные в строки, столбцы или значения. Когда макет готов — сохраните таблицу в мониторинг.",
              "reprocess": "Пересчитать аналитику",
              "saveCta": "Сохранить в мониторинг",
              "analyticsProcessed": "Обработано: {percent}%"
            },
            "empty": {
              "title": "Выберите переменные",
              "hint": "Выберите одну или несколько переменных из таблицы, чтобы начать анализ."
            },
            "save": {
              "title": "Сохранить таблицу мониторинга",
              "subtitle": "Дайте представлению имя, чтобы найти его на странице мониторинга.",
              "tableName": "Название таблицы",
              "tableNamePlaceholder": "Введите название",
              "description": "Описание",
              "descriptionPlaceholder": "Что отслеживает эта таблица?",
              "summary": "Сводка анализа",
              "variables": "Переменные",
              "table": "Таблица",
              "cancel": "Отмена",
              "confirm": "Сохранить таблицу"
            },
            "toasts": {
              "labelsGenerated": "Метки сгенерированы. Обновление переменных...",
              "labelsFailed": "Не удалось сгенерировать метки. Проверьте доступность XLSForm.",
              "saveSuccess": "Таблица сохранена. Откройте мониторинг данных для просмотра.",
              "saveFailed": "Не удалось сохранить таблицу. Повторите попытку или обратитесь в поддержку.",
              "formIdMissing": "ID формы не найден",
              "reprocessSuccess": "Аналитика пересчитана: {count} новых записей",
              "reprocessFailed": "Не удалось пересчитать аналитику",
              "reprocessError": "Ошибка пересчёта аналитики: {error}"
            }
          }
        },
        "dataMonitoring": {
          "title": "Мониторинг данных",
          "description": "Просмотр сохранённых таблиц мониторинга с обновлениями в реальном времени",
          "tablesCount": "Таблиц: {count}",
          "updating": "Обновление...",
          "workbench": {
            "contextHint": "Сохранённые сводные представления с обновлением данных, пока открыта эта страница",
            "activeViewsCount": "Активных: {count}",
            "liveStrip": {
              "ariaLabel": "Статус мониторинга",
              "saved": "Сохранённые таблицы",
              "savedHint": "Готово таблиц: {count}",
              "savedEmpty": "Таблицы ещё не сохранены",
              "watch": "Активный просмотр",
              "watchHint": "Просмотр: {title}",
              "watchEmpty": "Выберите таблицу для просмотра",
              "watchDisabled": "Сначала создайте таблицу",
              "sync": "Живое обновление",
              "syncHint": "Обновление каждые 30 секунд",
              "syncActive": "Обновление..."
            },
            "displayOptions": {
              "title": "Параметры отображения",
              "subtitle": "Управление отображением имён переменных в сводных таблицах",
              "showLabels": "Показывать метки",
              "language": "Язык"
            },
            "summary": {
              "title": "Краткий обзор",
              "tables": "Сохранённые таблицы",
              "activeView": "Активный просмотр",
              "records": "Записей в просмотре",
              "refreshInterval": "Автообновление"
            },
            "tables": {
              "title": "Таблицы мониторинга",
              "subtitle": "Сохранённые сводные представления из анализа данных",
              "loading": "Загрузка таблиц мониторинга...",
              "emptyTitle": "Таблиц мониторинга пока нет",
              "emptyHint": "Создайте сводную таблицу на странице анализа и сохраните её здесь.",
              "createCta": "Перейти к анализу",
              "realtimeHint": "Данные обновляются каждые 30 секунд, пока открыта эта страница. Нажмите «Обновить» для немедленного обновления.",
              "records": "Записей: {count}",
              "lastUpdated": "Обновлено {time}",
              "view": "Просмотр",
              "hide": "Скрыть",
              "loadingPivot": "Загрузка данных сводной таблицы...",
              "public": "Публичная",
              "private": "Приватная"
            },
            "delete": {
              "title": "Удалить таблицу",
              "confirm": "Удалить таблицу «{title}»?",
              "detail": "Таблица и её кэшированные данные будут удалены безвозвратно.",
              "cancel": "Отмена",
              "confirmBtn": "Удалить таблицу"
            }
          }
        },
        "settings": {
          "title": "Настройки",
          "description": "Управление настройками формы",
          "saveStatus": "Сохранить статус",
          "formStatus": "Статус формы",
          "basicSettings": "Основные настройки",
          "workbench": {
            "contextHint": "Настройка жизненного цикла, публичного доступа, ресурсов формы и обслуживания.",
            "basicHint": "Управляйте приёмом новых отправок и просматривайте опубликованные версии.",
            "badges": {
              "version": "Версия {version}",
              "publicOn": "Публичная ссылка включена",
              "publicOff": "Без публичной ссылки"
            },
            "lifecycle": {
              "ariaLabel": "Статус конфигурации формы",
              "publication": "Публикация",
              "published": "Опубликована {date}",
              "publishedNoDate": "Опубликована",
              "draft": "Черновик — ещё не опубликована",
              "collection": "Сбор данных",
              "collectionOpen": "Принимает отправки",
              "collectionClosing": "Закрывается — завершение в процессе",
              "collectionClosed": "Закрыта — новые отправки не принимаются",
              "collectionDraft": "Недоступно до публикации",
              "access": "Веб-доступ",
              "publicActive": "Публичная ссылка активна",
              "publicInactive": "Публичная ссылка не настроена"
            }
          },
          "notifications": {
            "noChanges": "Нет изменений для сохранения",
            "draftWarning": "Черновики форм нельзя изменить через этот интерфейс. Сначала опубликуйте форму.",
            "stateChangeHint": "Изменение статуса формы влияет на приём новых отправок.",
            "invalidState": "Недопустимый статус формы: {state}",
            "success": "Статус формы успешно изменен на {state}",
            "error": "Ошибка изменения статуса формы: {error}",
            "errorLog": "Ошибка изменения статуса формы"
          },
          "version": {
            "title": "Версия",
            "notSpecified": "Не указана",
            "history": "История версий",
            "noHistory": "История версий отсутствует",
            "download": "Скачать",
            "restore": "Восстановить",
            "uploadNew": "Загрузить новую версию",
            "author": "Автор",
            "loadError": "Не удалось загрузить версии: {error}",
            "downloadSuccess": "Версия скачана",
            "downloadError": "Не удалось скачать версию: {error}",
            "uploadSuccess": "Новая версия загружена"
          },
          "dataCollectors": {
            "title": "Сборщики данных",
            "description": "Управление доступом пользователей к сбору данных по форме",
            "noCollectors": "Нет назначенных сборщиков данных",
            "addCollector": "Добавить сборщика",
            "editCollector": "Редактировать сборщика",
            "removeCollector": "Удалить сборщика",
            "addCollectorModal": {
              "title": "Добавить сборщика данных",
              "placeholder": "Заглушка: здесь будет форма добавления сборщика данных"
            }
          },
          "publicAccess": {
            "title": "Публичный доступ",
            "description": "Создайте публичную ссылку для сбора данных через веб-интерфейс",
            "publicLink": "Публичная ссылка",
            "disable": "Отключить",
            "requireAuth": "Требовать аутентификацию",
            "collectEmail": "Собирать электронную почту",
            "limitSubmissions": "Ограничить количество ответов",
            "maxSubmissions": "Максимальное количество ответов",
            "updateSettings": "Обновить настройки",
            "createLink": "Создать публичную ссылку",
            "notCreated": "Публичная ссылка не создана. Создайте ссылку для сбора данных через веб-интерфейс.",
            "created": "Публичная ссылка создана",
            "copied": "Ссылка скопирована в буфер обмена",
            "disabled": "Публичная ссылка отключена",
            "updated": "Настройки публичной ссылки обновлены"
          },
          "webAccess": {
            "title": "Веб-форма",
            "description": "Публичная ссылка Enketo из ODK Central (с токеном доступа; вход в Central не нужен).",
            "linkLabel": "Публичная ссылка",
            "open": "Открыть",
            "copied": "Ссылка скопирована в буфер обмена",
            "copyError": "Не удалось скопировать ссылку",
            "enketoIdOnly": "Enketo ID: {id}. Укажите URL ODK-сервера в организации, чтобы собрать полную ссылку.",
            "notAvailable": "Нет активной публичной ссылки в ODK Central для этой формы. Создайте её в Central (Form → Public Access) и обновите страницу."
          },
          "qrCodes": {
            "title": "QR-коды для сбора данных",
            "description": "Создавайте и управляйте QR-кодами Collect на странице проекта.",
            "assignedTitle": "Назначенные QR-коды",
            "availableTitle": "Доступные QR-коды проекта",
            "createNew": "Создать новый QR-код",
            "noAvailable": "Нет доступных QR-кодов",
            "createInstruction": "Создайте QR-код для настройки устройств сбора данных",
            "manageOnProject": "QR-коды для ODK Collect управляются на уровне проекта (App Users).",
            "openProjectQr": "Открыть QR-коды проекта",
            "openFormAccess": "Управление доступом к формам",
            "notifications": {
              "assigned": "QR-код назначен форме",
              "unassigned": "QR-код отвязан от формы",
              "copied": "Base64 скопирован в буфер обмена",
              "copyError": "Ошибка копирования: {error}"
            }
          },
          "attachments": {
            "title": "Вложения и медиафайлы",
            "description": "Управление файлами и вложениями, связанными с формой",
            "xlsformFile": "XLSForm файл",
            "xlsformDescription": "Скачайте оригинальный XLSForm файл этой формы в формате Excel",
            "downloadXlsform": "Скачать XLSForm",
            "manageAttachments": "Управление вложениями",
            "downloadSuccess": "XLSForm файл успешно скачан",
            "downloadError": "Ошибка при скачивании XLSForm файла",
            "fileNotFound": "XLSForm файл не найден для этой формы",
            "accessDenied": "Нет доступа к скачиванию XLSForm файла",
            "serverError": "Ошибка сервера: {status}"
          },
          "analytics": {
            "title": "Управление аналитикой",
            "recreateAnalytics": "Принудительно пересоздать аналитику",
            "description": "Пересоздать аналитические данные для всех ответов формы. Используйте это, когда аналитические данные повреждены или отсутствуют.",
            "warning": "Эта операция удалит все существующие аналитические данные и пересоздаст их из исходных данных ответов.",
            "confirmTitle": "Подтверждение пересоздания аналитики",
            "alertTitle": "Предупреждение: Требуется пересоздание данных",
            "alertDescription": "Это действие навсегда удалит все существующие аналитические данные и пересоздаст их с нуля.",
            "whatWillHappen": "Что произойдет:",
            "step1": "Все существующие аналитические данные будут удалены",
            "step2": "Исходные данные ответов будут повторно обработаны",
            "step3": "Новые аналитические данные будут созданы с правильным форматированием",
            "step4": "Сводные таблицы и функции анализа будут работать правильно",
            "timeWarning": "Эта операция может занять несколько минут для форм с большим количеством ответов.",
            "recreateButton": "Принудительно пересоздать аналитику",
            "confirmButton": "Да, пересоздать аналитику",
            "success": "Аналитика успешно пересоздана! Обработано {processed} ответов, пересоздано {recreated} аналитических записей из {total} общих ответов.",
            "error": "Не удалось пересоздать аналитические данные",
            "apiError": "Ошибка API: {error}",
            "missingFormId": "Локальный ID формы отсутствует"
          },
          "dangerZone": {
            "title": "Опасная зона",
            "deleteForm": "Удаление формы",
            "description": "Это действие нельзя отменить. Все собранные данные будут потеряны.",
            "confirmDelete": "Подтверждение удаления формы",
            "confirmMessage": "Вы действительно хотите удалить форму \"{name}\"?",
            "confirmDescription": "Это действие нельзя отменить. Все собранные данные будут потеряны.",
            "enterFormName": "Введите название формы для подтверждения",
            "deleteFormButton": "Удалить форму",
            "formDeleted": "Форма удалена (функция-заглушка)"
          }
        },
        "datasets": {
          "title": "Датасеты",
          "description": "Управление датасетами и сущностями"
        }
      },
      "errors": {
        "missingParams": "Отсутствуют необходимые параметры для загрузки формы",
        "loadError": "Ошибка загрузки данных формы",
        "unknownError": "Неизвестная ошибка"
      }
    },
    "dashboard": {
      "loading": "Загрузка аналитики...",
      "analyticsError": "Ошибка при загрузке аналитики",
      "retry": "Повторить загрузку",
      "workbench": {
        "contextHint": "Идентификатор формы, сбор, timeline и AI для одного общего периода (7 / 30 / все).",
        "completionBadge": "Заполнение {rate}%",
        "metaVersion": "v{version}",
        "metaPublished": "опубл. {date}",
        "metaUpdated": "обнов. {date}",
        "summaryTitle": "Сводка по сбору",
        "sections": {
          "metadata": {
            "title": "Идентификатор формы",
            "xmlFormId": "XML ID формы",
            "version": "Версия",
            "published": "Опубликована",
            "updated": "Последнее обновление"
          },
          "intake": {
            "title": "Сводка по сбору",
            "subtitle": "Поступление ответов за сегодня, неделю и за всё время"
          },
          "quickLinks": {
            "title": "Быстрые ссылки"
          },
          "agent": {
            "title": "AI-ассистент",
            "subtitle": "Сводки, аналитические отчёты и чат по этой форме"
          },
          "timeline": {
            "title": "Динамика ответов",
            "subtitle": "Количество ответов по дням за выбранный период"
          },
          "map": {
            "title": "Географическое распределение",
            "subtitle": "Точки сбора с геоданными"
          }
        },
        "metrics": {
          "noChange": "Без изменений"
        },
        "intakeStrip": {
          "ariaLabel": "Статус поступления данных",
          "today": "Сегодня",
          "todayDelta": "{delta} к вчера",
          "todayFlat": "Как вчера",
          "week": "За неделю",
          "weekDelta": "{delta} к прошлой неделе",
          "weekFlat": "Как на прошлой неделе",
          "total": "Всего ответов",
          "totalHint": "Всего собрано по этой форме",
          "totalEmpty": "Ответов пока нет"
        }
      },
      "cards": {
        "totalSubmissions": {
          "title": "Всего ответов",
          "today": "сегодня"
        },
        "completedSubmissions": {
          "title": "Завершенные ответы",
          "rate": "процент завершения"
        },
        "dataCollectors": {
          "title": "Сборщики данных",
          "new": "новых"
        },
        "problematicSubmissions": {
          "title": "Проблемные ответы"
        },
        "submissionTimeline": {
          "title": "Временная шкала отправок",
          "totalForPeriod": "Всего за период",
          "noData": "Нет данных о временной шкале отправок",
          "noSubmissionsInPeriod": "Нет отправок за выбранный период",
          "stats": {
            "totalSubmissions": "Всего отправок",
            "maxPerDay": "Максимум за день",
            "trend": "Тенденция"
          },
          "timeframes": {
            "7days": "За 7 дней",
            "30days": "За 30 дней",
            "90days": "За 90 дней",
            "allFormData": "Все данные формы"
          },
          "trend": {
            "stable": "Без изменений",
            "growth": "Рост",
            "decline": "Снижение"
          },
          "hint": "Нажмите на столбец, чтобы увидеть детальную информацию за день"
        }
      }
    },
    "summaryCard": {
      "id": "ID",
      "statusNotSet": "Статус не установлен",
      "statusDescriptions": {
        "published": "Форма открыта для сбора данных",
        "closing": "Форма закрывается, новые ответы ограничены",
        "closed": "Форма закрыта, новые ответы не принимаются",
        "draft": "Форма в режиме черновика, не опубликована",
        "unknown": "Статус не распознан"
      },
      "stats": {
        "today": "За сегодня",
        "week": "За неделю",
        "total": "Всего собрано",
        "responses": "ответов на форму",
        "fromYesterday": "от вчера",
        "fromLastWeek": "от прошлой недели"
      },
      "info": {
        "version": "Версия",
        "notSpecified": "Не указана",
        "created": "Создана",
        "updated": "Обновлена",
        "notUpdated": "Не обновлялась",
        "published": "Опубликована",
        "notPublished": "Не опубликована",
        "notSpecifiedDate": "Не указано"
      },
      "trend": {
        "title": "Тенденция заполнения за последние 7 дней",
        "noData": "Нет данных",
        "growth": "Рост",
        "decline": "Снижение",
        "stable": "Без изменений"
      }
    },
    "attachments": {
      "title": "Вложения формы",
      "formLabel": "Форма:",
      "noAttachmentsRequired": "Вложения не требуются",
      "noAttachmentsDescription": "Данная форма не содержит ссылок на внешние файлы (изображения, документы и т.д.).",
      "noAttachmentsHint": "Если вы добавите ссылки на файлы в XLSForm, они автоматически появятся здесь.",
      "uploadSection": {
        "supportedFormats": "Поддерживаемые форматы:",
        "dropZoneTitles": {
          "uploadMissing": "Загрузите отсутствующие файлы",
          "updateExisting": "Обновите существующие файлы",
          "uploadFiles": "Загрузите файлы"
        },
        "dropZoneDescriptions": {
          "uploadMissing": "Ожидается {count} файл(ов): {files}",
          "updateExisting": "Все файлы загружены. Вы можете заменить их новыми версиями.",
          "uploadFiles": "Выберите файлы для загрузки вложений формы."
        },
        "dropZoneButtons": {
          "selectFiles": "Выбрать файлы",
          "updateFiles": "Обновить файлы",
          "chooseFiles": "Выбрать файлы"
        },
        "selectedFiles": "Выбранные файлы ({count})",
        "uploadButton": "Загрузить {count} файлов",
        "uploading": "Загружаем...",
        "clear": "Очистить",
        "chooseFiles": "Выбрать файлы"
      },
      "table": {
        "columns": {
          "name": "Имя файла",
          "status": "Статус",
          "type": "Тип",
          "size": "Размер",
          "updatedAt": "Дата загрузки",
          "actions": "Действия"
        },
        "status": {
          "uploaded": "Загружено",
          "missing": "Отсутствует",
          "deleted": "Удалено",
          "unknown": "Неизвестно"
        },
        "actions": {
          "download": "Скачать",
          "delete": "Удалить",
          "deleted": "Удален",
          "missing": "Отсутствует"
        },
        "notSpecified": "Не указано"
      },
      "messages": {
        "uploadSuccess": "Успешно загружено {count} файлов",
        "uploadError": "Ошибка загрузки файлов: {error}",
        "fileNotFound": "Файл {filename} не найден в выбранных файлах",
        "fileUploadSuccess": "Файл {filename} успешно загружен",
        "fileUploadError": "Ошибка загрузки файла {filename}: {error}",
        "downloadError": "Ошибка скачивания файла {filename}: {error}",
        "deleteSuccess": "Файл {filename} успешно удален",
        "deleteError": "Ошибка удаления файла {filename}: {error}",
        "invalidFilesIgnored": "Следующие файлы будут проигнорированы (не найдены в списке ожидаемых): {files}",
        "filesWillBeUpdated": "Следующие файлы будут обновлены: {files}",
        "loadingError": "Ошибка загрузки вложений",
        "downloadSuccess": "Файл {filename} успешно скачан",
        "fileAlreadyDeleted": "Файл {filename} уже был удален или не существует",
        "fileNotInExpectedList": "Файл не найден в списке ожидаемых вложений"
      },
      "confirmDelete": {
        "title": "Подтверждение удаления",
        "message": "Вы уверены, что хотите удалить файл \"{filename}\"?",
        "warning": "Это действие нельзя отменить.",
        "deleting": "Удаляем...",
        "delete": "Удалить"
      }
    }
  },
  "pageNotFound": {
    "title": "Упс! Страница не найдена.",
    "subtitle": "404",
    "description": "Страница, которую вы ищете, не существует или была перемещена.",
    "goBack": "Назад",
    "goHome": "На главную",
    "copyright": "© {year} UDACAPI. Все права защищены."
  },
  "maps": {
    "tabTitle": "Карта",
    "pageTitle": "Карта проекта",
    "subtitle": "Мониторинг собранных данных с GPS-координатами в реальном времени",
    "empty": {
      "noGeoForms": "В этом проекте пока нет форм с GPS-вопросами.",
      "noPoints": "Нет отправок, подходящих под текущие фильтры."
    },
    "filters": {
      "title": "Фильтры",
      "forms": "Формы",
      "dateFrom": "С",
      "dateTo": "По",
      "qcStatus": "Статус QC",
      "enumerator": "Энумератор",
      "heatmap": "Тепловая карта",
      "reset": "Сбросить фильтры",
      "apply": "Применить"
    },
    "qcStatuses": {
      "any": "Любой",
      "pass": "Пройден",
      "fail": "Провален",
      "warning": "Предупреждение",
      "error": "Ошибка",
      "none": "Не проверено"
    },
    "actions": {
      "export": "Экспорт в GeoJSON",
      "refresh": "Обновить",
      "settings": "Настройки карты",
      "openSubmission": "Открыть отправку",
      "openFormOnMap": "Посмотреть форму на карте"
    },
    "popup": {
      "submittedAt": "Отправлено",
      "submittedBy": "Отправитель",
      "form": "Форма",
      "status": "Статус QC"
    },
    "truncated": "Показаны первые {limit} точек. Уточните фильтры или включите кластеризацию, чтобы увидеть больше.",
    "settingsDialog": {
      "title": "Настройки карты проекта",
      "defaultCenter": "Центр по умолчанию",
      "defaultCenterHint": "Щёлкните по карте, чтобы выбрать точку",
      "defaultZoom": "Масштаб по умолчанию",
      "defaultForms": "Формы по умолчанию",
      "heatmapDefault": "Включать тепловую карту по умолчанию",
      "coordinateFields": "Поля координат",
      "latitudeField": "Поле широты",
      "longitudeField": "Поле долготы",
      "automaticDetection": "Использовать автоопределение",
      "coordinateSourceTitle": "Источник координат",
      "coordinateMode": "Режим координат",
      "modeAuto": "Автоопределение",
      "modeNone": "Нет геоданных",
      "modeLatLon": "Поля широты и долготы",
      "modeGeopoint": "Поле geopoint",
      "geopointField": "Поле geopoint",
      "detectedSource": "Автоопределённый источник: {path} · точек сейчас: {count}",
      "configureCoordinates": "Поля координат",
      "noMapHint": "Нет точек на карте для этой формы. Настройте координатные поля, если в сабмишенах есть локации.",
      "save": "Сохранить",
      "cancel": "Отмена",
      "saved": "Настройки сохранены"
    },
    "savedViews": {
      "title": "Сохраненные виды",
      "noViewsYet": "Нет сохранённых видов — создайте на карте проекта",
      "recommended": "Рекомендуемый",
      "defaultLabel": "по умолчанию",
      "saveHint": "После Apply карта использует выбранные фильтры и тепловую карту. «Сохранить текущий вид» сохраняет эту конфигурацию под именем (только для менеджеров проекта).",
      "saveCurrent": "Сохранить текущий вид",
      "updateCurrent": "Обновить вид",
      "delete": "Удалить вид",
      "name": "Название вида",
      "pinAsDefault": "Сделать видом по умолчанию",
      "pin": "Закрепить вид",
      "saved": "Вид сохранен",
      "updated": "Вид обновлен",
      "deleted": "Вид удален",
      "saveFailed": "Не удалось сохранить вид. Проверьте, что на сервере есть эндпоинты map/views и применены миграции (таблица project_map_views).",
      "updateFailed": "Не удалось обновить вид.",
      "deleteFailed": "Не удалось удалить вид."
    },
    "tileConfig": {
      "sectionTitle": "Сервер тайлов карты",
      "sectionDescription": "Укажите собственный URL-шаблон тайл-сервера для организации. Оставьте пустым, чтобы использовать публичные тайлы OpenStreetMap.",
      "url": "URL-шаблон тайлов",
      "urlPlaceholder": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      "attribution": "Атрибуция",
      "subdomains": "Поддомены",
      "maxZoom": "Макс. масштаб",
      "minZoom": "Мин. масштаб",
      "test": "Проверить URL",
      "configure": "Настроить",
      "edit": "Изменить",
      "defaultTiles": "Используются публичные тайлы OpenStreetMap",
      "zoom": "Масштаб",
      "clear": "Очистить",
      "save": "Сохранить",
      "saved": "Конфигурация тайлов сохранена",
      "cleared": "Пользовательский сервер тайлов очищен"
    }
  },
  "shareDashboard": {
    "shareButton": "Поделиться дашбордом",
    "dialogTitle": "Поделиться дашбордом",
    "dialogHint": "Создайте секретную ссылку для клиентов: живой просмотр только для чтения. Рекомендуется PIN.",
    "label": "Название",
    "pinOptional": "PIN (необязательно)",
    "pinPlaceholder": "Не меньше 4 символов",
    "pin": "PIN",
    "create": "Создать ссылку",
    "created": "Ссылка создана",
    "createError": "Не удалось создать ссылку",
    "copyOnce": "Скопируйте сейчас — полная ссылка показывается один раз",
    "copy": "Копировать",
    "copied": "Скопировано",
    "copyError": "Не удалось скопировать",
    "existing": "Существующие ссылки",
    "refresh": "Обновить",
    "loadingLinks": "Загрузка ссылок…",
    "empty": "Ссылок пока нет",
    "untitled": "Без названия",
    "overviewHint": "Живая сводка сбора по этой общей форме",
    "loadFormsError": "Не удалось загрузить формы",
    "revoke": "Отозвать",
    "revokeTitle": "Отозвать ссылку",
    "revokeConfirm": "Клиенты с этой ссылкой сразу потеряют доступ.",
    "revokeError": "Не удалось отозвать ссылку",
    "revoked": "Отозвана",
    "expired": "Истекла",
    "expires": "Истекает",
    "loadError": "Не удалось загрузить ссылки",
    "openBriefing": "Открыть брифинг",
    "pinGateHint": "Введите PIN, выданный вместе со ссылкой.",
    "invalidPin": "Неверный PIN",
    "expiredLink": "Срок действия ссылки истёк",
    "askManager": "Попросите менеджера проекта выдать новую ссылку",
    "loading": "Открываем брифинг…",
    "briefing": "Полевой брифинг",
    "updated": "Обновлено",
    "pickForm": "Выберите форму",
    "backToForms": "Все формы",
    "submissions": "Отправки",
    "noSubmissions": "В этой форме пока нет отправок",
    "view": "Открыть",
    "submissionDetail": "Отправка",
    "close": "Закрыть",
    "totalSubmissions": "Отправки",
    "today": "Сегодня",
    "thisWeek": "На этой неделе",
    "collectors": "Сборщики",
    "analyticsError": "Не удалось загрузить сводку сбора",
    "submissionsError": "Не удалось загрузить список отправок"
  }
}
